var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: { "image-analysis-with-visibility": _vm.commerceVisibilityOpen } },
    [
      _vm.commerceVisibilityMounted
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.commerceVisibilityOpen,
                  expression: "commerceVisibilityOpen",
                },
              ],
              staticClass: "commerce-visibility-container",
            },
            [
              _c(
                "CommerceVisibilityReport",
                _vm._b(
                  {
                    attrs: {
                      embedded: "",
                      active:
                        _vm.commerceVisibilityOpen &&
                        _vm.commerceVisibilityTabActive,
                      "initial-selection":
                        _vm.commerceVisibilityInitialSelection,
                    },
                    on: {
                      "selection-change": _vm.onCommerceVisibilitySelection,
                      back: _vm.closeCommerceVisibility,
                    },
                  },
                  "CommerceVisibilityReport",
                  _vm.commerceVisibilityProps,
                  false
                )
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isOptixLab
        ? _c("StepProgressBar", {
            attrs: {
              title:
                _vm.step > 2
                  ? _vm.selectedPrompts.map((p) => p.name).join(", ")
                  : "Analyze Images",
              "current-step": _vm.step - 1,
              "max-steps": _vm.lastStep - 1,
            },
          })
        : !_vm.isConfigViewOpen
        ? _c("div", { staticClass: "step-progress-bar mb-3" }, [
            _c(
              "div",
              {
                staticClass: "d-flex justify-content-between align-items-start",
              },
              [
                _c("div", [
                  !_vm.isConfigViewOpen &&
                  _vm.isVisualPlayBookAnalysis() &&
                  _vm.step === 3
                    ? _c("div", { staticClass: "editable-title-container" }, [
                        _vm.isEditingReportName
                          ? _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.visualBenchmarkReportName,
                                  expression: "visualBenchmarkReportName",
                                },
                              ],
                              ref: "reportNameInput",
                              staticClass: "editable-report-title",
                              attrs: {
                                type: "text",
                                placeholder: "Enter report name",
                              },
                              domProps: {
                                value: _vm.visualBenchmarkReportName,
                              },
                              on: {
                                blur: function ($event) {
                                  _vm.isEditingReportName = false
                                },
                                keyup: [
                                  function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    )
                                      return null
                                    _vm.isEditingReportName = false
                                  },
                                  function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "escape",
                                        undefined,
                                        $event.key,
                                        undefined
                                      )
                                    )
                                      return null
                                    _vm.isEditingReportName = false
                                  },
                                ],
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.visualBenchmarkReportName =
                                    $event.target.value
                                },
                              },
                            })
                          : _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex align-items-center report-title-display",
                                on: { click: _vm.startEditingReportName },
                              },
                              [
                                _c(
                                  "h5",
                                  { staticClass: "mb-0 font-weight-bold" },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.visualBenchmarkReportName ||
                                            "Untitled Report"
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("b-icon", {
                                  staticClass:
                                    "text-muted ml-2 edit-pencil-icon",
                                  attrs: { icon: "pencil" },
                                }),
                              ],
                              1
                            ),
                      ])
                    : !_vm.isConfigViewOpen
                    ? _c("h5", { staticClass: "mb-0 font-weight-bold" }, [
                        _vm._v(
                          "\n          " + _vm._s(_vm.stepTitle) + "\n        "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  (_vm.step === 2 || _vm.step === 3) && !_vm.isConfigViewOpen
                    ? _c("p", { staticClass: "text-muted mt-1 mb-0" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.isVisualPlayBookAnalysis() && _vm.step === 3
                                ? "Visual Insights by Category"
                                : _vm.stepDescription || "\u00A0"
                            ) +
                            "\n        "
                        ),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _vm.isOptixLab &&
                !_vm.isConfigViewOpen &&
                !(_vm.isVisualPlayBookAnalysis() && _vm.step === 3)
                  ? _c(
                      "div",
                      {
                        staticClass: "d-flex align-items-center",
                        staticStyle: { gap: "8px" },
                      },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "configure-audiences-btn",
                            attrs: { variant: "outline-secondary", size: "sm" },
                            on: { click: _vm.toggleAudiencesList },
                          },
                          [
                            _c("b-icon", { attrs: { icon: "people" } }),
                            _vm._v("\n          Configure Audiences\n        "),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "position-relative" },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "pim-dam-gear-btn",
                                attrs: {
                                  variant: "outline-secondary",
                                  size: "sm",
                                },
                                on: { click: _vm.togglePimDamDropdown },
                              },
                              [_c("b-icon", { attrs: { icon: "sliders" } })],
                              1
                            ),
                            _vm._v(" "),
                            _vm.showPimDamDropdown
                              ? _c("div", { staticClass: "pim-dam-dropdown" }, [
                                  _c(
                                    "div",
                                    { staticClass: "pim-dam-dropdown-header" },
                                    [
                                      _vm._v(
                                        "\n              PIM / DAM Connections\n            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "pim-dam-dropdown-item" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "pim-dam-label" },
                                        [
                                          _vm._v(
                                            "\n                Salsify\n                "
                                          ),
                                          _c("span", {
                                            staticClass: "pim-dam-dot",
                                            class: {
                                              connected: _vm.isSalsifyConnected,
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.isSalsifyConnected
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "pim-dam-status connected",
                                            },
                                            [
                                              _vm._v(
                                                "\n                Connected\n              "
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "a",
                                            {
                                              staticClass:
                                                "pim-dam-connect-link",
                                              attrs: {
                                                href: "javascript:void(0)",
                                              },
                                              on: {
                                                click:
                                                  _vm.openSetupConnectionModal,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                Connect\n              "
                                              ),
                                            ]
                                          ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "pim-dam-dropdown-item" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "pim-dam-label" },
                                        [
                                          _vm._v(
                                            "\n                Bynder\n                "
                                          ),
                                          _c("span", {
                                            staticClass: "pim-dam-dot",
                                            class: {
                                              connected: _vm.isBynderConnected,
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.isBynderConnected
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "pim-dam-status connected",
                                            },
                                            [
                                              _vm._v(
                                                "\n                Connected\n              "
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "a",
                                            {
                                              staticClass:
                                                "pim-dam-connect-link",
                                              attrs: {
                                                href: "javascript:void(0)",
                                              },
                                              on: {
                                                click:
                                                  _vm.openSetupConnectionModal,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                Connect\n              "
                                              ),
                                            ]
                                          ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  !_vm.isSalsifyConnected &&
                                  !_vm.isBynderConnected
                                    ? _c(
                                        "div",
                                        { staticClass: "pim-dam-warning" },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "bi bi-exclamation-circle",
                                          }),
                                          _vm._v(
                                            "\n              No PIM/DAM connected\n            "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isOptixLab &&
      !_vm.isConfigViewOpen &&
      (_vm.step === 2 || (_vm.step === 3 && _vm.viewMode === "list"))
        ? _c(
            "div",
            {
              staticClass: "d-flex align-items-center mb-3",
              staticStyle: { gap: "12px" },
            },
            [
              _c("div", { staticClass: "position-relative flex-grow-1" }, [
                _c("i", {
                  staticClass: "bi bi-search position-absolute",
                  staticStyle: {
                    left: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "#6c757d",
                  },
                }),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.promptsSearchQuery,
                      expression: "promptsSearchQuery",
                    },
                  ],
                  staticClass: "form-control",
                  staticStyle: {
                    "padding-left": "38px",
                    "padding-right": "38px",
                  },
                  attrs: {
                    id: "search-analysis-types",
                    type: "text",
                    placeholder: "Search analysis types...",
                  },
                  domProps: { value: _vm.promptsSearchQuery },
                  on: {
                    input: [
                      function ($event) {
                        if ($event.target.composing) return
                        _vm.promptsSearchQuery = $event.target.value
                      },
                      _vm.updatePromptsSearchQuery,
                    ],
                  },
                }),
                _vm._v(" "),
                _vm.promptsSearchQuery
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-link position-absolute",
                        staticStyle: {
                          right: "5px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          padding: "0",
                          color: "#6c757d",
                          "text-decoration": "none",
                        },
                        attrs: { type: "button", title: "Clear search" },
                        on: {
                          click: function ($event) {
                            _vm.promptsSearchQuery = ""
                          },
                        },
                      },
                      [_c("i", { staticClass: "bi bi-x-circle" })]
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.promptsTagFilter,
                      expression: "promptsTagFilter",
                    },
                  ],
                  staticClass: "form-control",
                  staticStyle: { width: "auto", "min-width": "150px" },
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.promptsTagFilter = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                [
                  _c("option", { attrs: { value: "" } }, [
                    _vm._v("\n        All\n      "),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.availableTags, function (tag) {
                    return _c(
                      "option",
                      { key: tag, domProps: { value: tag } },
                      [_vm._v("\n        " + _vm._s(tag) + "\n      ")]
                    )
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "view-toggle-buttons" }, [
                _c(
                  "button",
                  {
                    staticClass: "view-toggle-btn",
                    class: { active: _vm.viewMode === "list" },
                    attrs: { type: "button", title: "List View" },
                    on: {
                      click: function ($event) {
                        return _vm.setViewMode("list")
                      },
                    },
                  },
                  [_c("i", { staticClass: "bi bi-list" })]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "view-toggle-btn",
                    class: { active: _vm.viewMode === "gallery" },
                    attrs: { type: "button", title: "Gallery View" },
                    on: {
                      click: function ($event) {
                        return _vm.setViewMode("gallery")
                      },
                    },
                  },
                  [_c("i", { staticClass: "bi bi-grid" })]
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showAudiencesList && _vm.isOptixLab
        ? [
            _c("div", { staticClass: "audiences-config__backrow" }, [
              _c(
                "button",
                {
                  staticClass:
                    "btn btn-link audiences-config__back d-flex align-items-center mb-4",
                  attrs: { type: "button" },
                  on: { click: _vm.toggleAudiencesList },
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "mr-2",
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                      },
                    },
                    [
                      _c("path", { attrs: { d: "m12 19-7-7 7-7" } }),
                      _vm._v(" "),
                      _c("path", { attrs: { d: "M19 12H5" } }),
                    ]
                  ),
                  _vm._v("\n        Back to Optix Lab\n      "),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("AudiencePage", {
              attrs: {
                "show-modal": _vm.showAudienceModalFlag,
                "from-analysis": _vm.creatingFromAnalysisFlow,
              },
              on: {
                "update-audiences-analysis": _vm.updateAudienceAnalysis,
                "update-audiences": _vm.updateAudience,
              },
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.showBrandGuidelinesList && _vm.isOptixLab
        ? [
            !_vm.isBrandGuidelinesEditMode
              ? _c("div", { staticClass: "audiences-config__backrow" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-link audiences-config__back d-flex align-items-center mb-4",
                      attrs: { type: "button" },
                      on: { click: _vm.toggleBrandGuidelinesList },
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "mr-2",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "24",
                            height: "24",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        },
                        [
                          _c("path", { attrs: { d: "m12 19-7-7 7-7" } }),
                          _vm._v(" "),
                          _c("path", { attrs: { d: "M19 12H5" } }),
                        ]
                      ),
                      _vm._v("\n        Back to Optix Lab\n      "),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "optix-brand-guidelines",
                class: {
                  "optix-brand-guidelines--editing":
                    _vm.isBrandGuidelinesEditMode,
                },
              },
              [
                _c("BrandGuidelines", {
                  attrs: {
                    "from-analysis": _vm.creatingBrandGuidelineFromAnalysisFlow,
                  },
                  on: {
                    "edit-mode-change": function ($event) {
                      _vm.isBrandGuidelinesEditMode = $event
                    },
                    "update-brand-guidelines-analysis":
                      _vm.updateBrandGuidelinesAnalysis,
                    "update-brand-guidelines": _vm.updateBrandGuidelines,
                  },
                }),
              ],
              1
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.step === 1 && !_vm.isConfigViewOpen
        ? [
            _c("div", { staticClass: "card-selection-container" }, [
              _c("div", { staticClass: "card-grid" }, [
                _c(
                  "div",
                  {
                    staticClass: "selection-card",
                    class: { selected: _vm.selectedImageType === "pdp" },
                    on: {
                      click: function ($event) {
                        return _vm.select("pdp")
                      },
                    },
                  },
                  [
                    _vm.selectedImageType === "pdp"
                      ? _c("div", { staticClass: "selected-indicator" }, [
                          _c("i", { staticClass: "bi bi-check2 checkmark" }),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "select-button",
                        class: { selected: _vm.selectedImageType === "pdp" },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.selectedImageType === "pdp"
                                ? "Selected"
                                : "Select"
                            ) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "selection-card",
                    class: { selected: _vm.selectedImageType === "banner" },
                    on: {
                      click: function ($event) {
                        return _vm.select("banner")
                      },
                    },
                  },
                  [
                    _vm.selectedImageType === "banner"
                      ? _c("div", { staticClass: "selected-indicator" }, [
                          _c("i", { staticClass: "bi bi-check2 checkmark" }),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._m(1),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "select-button",
                        class: { selected: _vm.selectedImageType === "banner" },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.selectedImageType === "banner"
                                ? "Selected"
                                : "Select"
                            ) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]
                ),
              ]),
            ]),
          ]
        : _vm.step === 2 && !_vm.isConfigViewOpen
        ? _c(
            "div",
            [
              _vm.isOptixLab &&
              _vm.dashboardPrompts.length === 0 &&
              _vm.promptsSearchQuery
                ? _c("div", { staticClass: "text-center py-5" }, [
                    _c("i", {
                      staticClass: "fas fa-search fa-3x text-muted mb-3",
                    }),
                    _vm._v(" "),
                    _c("p", { staticClass: "text-muted" }, [
                      _vm._v(
                        '\n        No analysis types found matching "' +
                          _vm._s(_vm.promptsSearchQuery) +
                          '".\n      '
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary",
                        on: {
                          click: function ($event) {
                            _vm.promptsSearchQuery = ""
                          },
                        },
                      },
                      [_vm._v("\n        Clear Search\n      ")]
                    ),
                  ])
                : _vm.isOptixLab
                ? _c(
                    "div",
                    { staticClass: "prompts-grid" },
                    _vm._l(_vm.dashboardPrompts, function (prompt) {
                      return _c(
                        "div",
                        {
                          key: prompt.id,
                          staticClass: "prompt-card cursor-pointer",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.startAnalysisWithPrompt(prompt)
                            },
                          },
                        },
                        [
                          prompt.tag
                            ? _c("span", { staticClass: "prompt-tag-badge" }, [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(prompt.tag) +
                                    "\n        "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "prompt-card-header" }, [
                            _c("div", { staticClass: "prompt-icon" }, [
                              prompt.icon === "custom-ab-test"
                                ? _c("img", {
                                    staticStyle: {
                                      width: "20px",
                                      height: "20px",
                                    },
                                    attrs: {
                                      src: "/img/icons/ab-testing.svg",
                                      alt: "A/B Test icon",
                                    },
                                  })
                                : prompt.icon === "custom-image-order"
                                ? _c("img", {
                                    staticStyle: {
                                      width: "20px",
                                      height: "20px",
                                    },
                                    attrs: {
                                      src: "/img/icons/image-order.svg",
                                      alt: "Image Order icon",
                                    },
                                  })
                                : prompt.icon === "custom-prioritize"
                                ? _c("img", {
                                    staticStyle: {
                                      width: "20px",
                                      height: "20px",
                                    },
                                    attrs: {
                                      src: "/img/icons/prioritize.svg",
                                      alt: "Prioritize icon",
                                    },
                                  })
                                : prompt.icon === "custom-holidays"
                                ? _c("img", {
                                    staticStyle: {
                                      width: "20px",
                                      height: "20px",
                                    },
                                    attrs: {
                                      src: "/img/icons/gift-box.svg",
                                      alt: "Holidays icon",
                                    },
                                  })
                                : prompt.icon &&
                                  prompt.icon.startsWith("lucide-")
                                ? _c("i", {
                                    staticClass: "lucide-icon",
                                    staticStyle: {
                                      width: "20px",
                                      height: "20px",
                                    },
                                    attrs: {
                                      "data-lucide": prompt.icon.replace(
                                        "lucide-",
                                        ""
                                      ),
                                    },
                                  })
                                : prompt.icon && prompt.icon.trim()
                                ? _c("i", { class: prompt.icon })
                                : _c("i", {
                                    staticClass: "bi bi-lightbulb-fill",
                                  }),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "prompt-meta" }, [
                              _c("div", { staticClass: "prompt-title" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(prompt.display_name || prompt.name) +
                                    "\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "prompt-desc" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(prompt.short_description || "") +
                                    "\n            "
                                ),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm._m(2, true),
                        ]
                      )
                    }),
                    0
                  )
                : _c(
                    "b-form-group",
                    {
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex align-items-center gap-2",
                                },
                                [_c("span", [_vm._v("Analysis Type:")])]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _vm._v(" "),
                      _c("Multiselect", {
                        attrs: {
                          label: "name",
                          "track-by": "id",
                          "allow-empty": true,
                          options: _vm.promptOptions,
                          disabled:
                            _vm.customPrompts.length === 0 ||
                            _vm.customPrompts[0] === "loading",
                          multiple: true,
                        },
                        model: {
                          value: _vm.selectedPrompts,
                          callback: function ($$v) {
                            _vm.selectedPrompts = $$v
                          },
                          expression: "selectedPrompts",
                        },
                      }),
                    ],
                    1
                  ),
              _vm._v(" "),
              _vm.presets.length
                ? _c("div", [
                    _c("span", [_vm._v("Selected images:")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "image-grid" },
                      _vm._l(_vm.presets, function (template, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "image-card" },
                          [
                            _c("img", {
                              attrs: {
                                src: _vm.getPresetThumbnailUrl(
                                  template.thumbnail
                                ),
                                alt: `generated_image_${index + 1}`,
                                loading: "lazy",
                              },
                            }),
                          ]
                        )
                      }),
                      0
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.isOptixLab
                ? _c("div", [
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "div",
                        { staticClass: "form-check" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.isBackgroundJob,
                                expression: "isBackgroundJob",
                              },
                            ],
                            staticClass: "form-check-input",
                            attrs: { id: "background_job", type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(_vm.isBackgroundJob)
                                ? _vm._i(_vm.isBackgroundJob, null) > -1
                                : _vm.isBackgroundJob,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.isBackgroundJob,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.isBackgroundJob = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.isBackgroundJob = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.isBackgroundJob = $$c
                                }
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              attrs: {
                                id: "background_job_tooltip",
                                for: "background_job",
                              },
                            },
                            [
                              _vm._v(
                                "\n            Run in background\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("b-tooltip", {
                            attrs: {
                              target: "background_job_tooltip",
                              triggers: "hover",
                              title:
                                "The report will be generated automatically in the background. You'll be notified once it's ready.",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ])
                : _vm._e(),
            ],
            1
          )
        : _vm.step === 3
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isConfigViewOpen,
                  expression: "!isConfigViewOpen",
                },
              ],
              class: {
                "list-view-container":
                  _vm.isOptixLab && _vm.viewMode === "list",
              },
            },
            [
              _c(
                "div",
                {
                  class: {
                    "list-view-split":
                      _vm.isOptixLab && _vm.viewMode === "list",
                  },
                },
                [
                  _vm.isOptixLab && _vm.viewMode === "list"
                    ? _c("div", { staticClass: "list-view-left-panel" }, [
                        _c(
                          "div",
                          { staticClass: "analysis-types-list" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "analysis-type-item select-all-item",
                              },
                              [
                                _c("b-form-checkbox", {
                                  attrs: {
                                    checked: _vm.allPromptsSelectedListView,
                                  },
                                  on: {
                                    change: _vm.toggleSelectAllPromptsListView,
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "analysis-type-name cursor-pointer",
                                    on: {
                                      click: _vm.toggleSelectAllPromptsListView,
                                    },
                                  },
                                  [_vm._v("Select all")]
                                ),
                                _vm._v(" "),
                                _vm.selectedPromptsListView.length > 0
                                  ? _c(
                                      "a",
                                      {
                                        staticClass:
                                          "clear-selection-link ml-auto",
                                        attrs: { href: "#" },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            $event.preventDefault()
                                            return _vm.clearAllPromptsListView.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n              Clear\n            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.dashboardPrompts, function (prompt) {
                              return _c(
                                "div",
                                {
                                  key: "list-" + prompt.id,
                                  staticClass: "analysis-type-item",
                                  class: {
                                    selected:
                                      _vm.isPromptSelectedListView(prompt),
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.togglePromptSelectionListView(
                                        prompt
                                      )
                                    },
                                  },
                                },
                                [
                                  prompt.launch_url
                                    ? _c(
                                        "a",
                                        {
                                          staticClass:
                                            "btn btn-sm btn-outline-success mr-2",
                                          attrs: { href: prompt.launch_url },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              $event.preventDefault()
                                              return _vm.openStandaloneReport(
                                                prompt
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("Open →")]
                                      )
                                    : _c("b-form-checkbox", {
                                        attrs: {
                                          checked:
                                            _vm.isPromptSelectedListView(
                                              prompt
                                            ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.togglePromptSelectionListView(
                                              prompt
                                            )
                                          },
                                          click: function ($event) {
                                            $event.stopPropagation()
                                          },
                                        },
                                      }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "analysis-type-icon",
                                      class: {
                                        selected:
                                          _vm.isPromptSelectedListView(prompt),
                                      },
                                    },
                                    [
                                      prompt.icon === "custom-ab-test"
                                        ? _c("img", {
                                            staticStyle: {
                                              width: "18px",
                                              height: "18px",
                                            },
                                            attrs: {
                                              src: "/img/icons/ab-testing.svg",
                                              alt: "A/B Test icon",
                                            },
                                          })
                                        : prompt.icon === "custom-image-order"
                                        ? _c("img", {
                                            staticStyle: {
                                              width: "18px",
                                              height: "18px",
                                            },
                                            attrs: {
                                              src: "/img/icons/image-order.svg",
                                              alt: "Image Order icon",
                                            },
                                          })
                                        : prompt.icon === "custom-prioritize"
                                        ? _c("img", {
                                            staticStyle: {
                                              width: "18px",
                                              height: "18px",
                                            },
                                            attrs: {
                                              src: "/img/icons/prioritize.svg",
                                              alt: "Prioritize icon",
                                            },
                                          })
                                        : prompt.icon === "custom-holidays"
                                        ? _c("img", {
                                            staticStyle: {
                                              width: "18px",
                                              height: "18px",
                                            },
                                            attrs: {
                                              src: "/img/icons/gift-box.svg",
                                              alt: "Holidays icon",
                                            },
                                          })
                                        : prompt.icon &&
                                          prompt.icon.startsWith("lucide-")
                                        ? _c("i", {
                                            staticClass: "lucide-icon",
                                            staticStyle: {
                                              width: "18px",
                                              height: "18px",
                                            },
                                            attrs: {
                                              "data-lucide":
                                                prompt.icon.replace(
                                                  "lucide-",
                                                  ""
                                                ),
                                            },
                                          })
                                        : prompt.icon && prompt.icon.trim()
                                        ? _c("i", { class: prompt.icon })
                                        : _c("i", {
                                            staticClass: "bi bi-lightbulb-fill",
                                          }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "analysis-type-name-wrapper",
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "analysis-type-name" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              prompt.display_name || prompt.name
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      prompt.tag
                                        ? _c(
                                            "b-badge",
                                            {
                                              staticClass:
                                                "prompt-tag-badge-inline",
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(prompt.tag) +
                                                  "\n              "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  prompt.short_description
                                    ? _c("i", {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover.left",
                                            modifiers: {
                                              hover: true,
                                              left: true,
                                            },
                                          },
                                        ],
                                        staticClass:
                                          "bi bi-info-circle analysis-type-info-icon ml-auto",
                                        attrs: {
                                          title: prompt.short_description,
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              )
                            }),
                          ],
                          2
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: {
                        "list-view-right-panel":
                          _vm.isOptixLab && _vm.viewMode === "list",
                      },
                    },
                    [
                      !_vm.isVisualPlayBookAnalysis() &&
                      !_vm.isShopperInsightsReport()
                        ? _c(
                            "b-tabs",
                            {
                              class: [
                                "custom-accessibility-tabs",
                                {
                                  "reversed-tabs":
                                    _vm.isImageComparisonAnalysis(),
                                },
                              ],
                              attrs: { "content-class": "mt-3", justified: "" },
                              model: {
                                value: _vm.activeTab,
                                callback: function ($$v) {
                                  _vm.activeTab = $$v
                                },
                                expression: "activeTab",
                              },
                            },
                            [
                              !_vm.isImageOrderAnalysis()
                                ? _c(
                                    "b-tab",
                                    {
                                      attrs: { active: _vm.activeTab === 0 },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "title",
                                            fn: function () {
                                              return [
                                                _c("b-icon", {
                                                  staticClass: "mr-2",
                                                  attrs: { icon: "upload" },
                                                }),
                                                _vm._v(
                                                  "\n              " +
                                                    _vm._s(
                                                      _vm.isImageComparisonAnalysis()
                                                        ? "Step 2: Upload Images"
                                                        : "Upload Images"
                                                    ) +
                                                    "\n            "
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        1694332329
                                      ),
                                    },
                                    [
                                      _vm._v(" "),
                                      _c(
                                        "b-overlay",
                                        {
                                          attrs: {
                                            show:
                                              _vm.isLoadingRerunImages ||
                                              _vm.isLoadingFileBrowserImages,
                                            rounded: "sm",
                                            opacity: "0.75",
                                            "spinner-variant": "primary",
                                            "z-index": 2000,
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "overlay",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "image-loading-overlay text-center",
                                                      },
                                                      [
                                                        _c("b-spinner", {
                                                          staticClass:
                                                            "image-loading-spinner",
                                                          attrs: {
                                                            label: "Loading...",
                                                            variant: "primary",
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "mt-3 font-weight-bold",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                    " +
                                                                _vm._s(
                                                                  _vm.isLoadingFileBrowserImages
                                                                    ? "Loading selected files..."
                                                                    : "Loading images from previous report..."
                                                                ) +
                                                                "\n                  "
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _vm.isLoadingFileBrowserImages
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "text-muted mt-1",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                    " +
                                                                    _vm._s(
                                                                      _vm.fileBrowserImagesLoaded
                                                                    ) +
                                                                    " of " +
                                                                    _vm._s(
                                                                      _vm.fileBrowserImagesTotal
                                                                    ) +
                                                                    " files loaded\n                  "
                                                                ),
                                                              ]
                                                            )
                                                          : _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "text-muted mt-1",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                    Please wait while we prepare your images\n                  "
                                                                ),
                                                              ]
                                                            ),
                                                        _vm._v(" "),
                                                        _vm.isLoadingFileBrowserImages &&
                                                        _vm.fileBrowserImagesTotal >
                                                          0
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "image-loading-progress mt-3",
                                                              },
                                                              [
                                                                _c("div", {
                                                                  staticClass:
                                                                    "image-loading-progress-bar",
                                                                  style: {
                                                                    width: `${Math.round(
                                                                      (_vm.fileBrowserImagesLoaded /
                                                                        _vm.fileBrowserImagesTotal) *
                                                                        100
                                                                    )}%`,
                                                                  },
                                                                }),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            false,
                                            1855477422
                                          ),
                                        },
                                        [
                                          _vm._v(" "),
                                          !_vm.isVisualPlayBookAnalysis()
                                            ? _c(
                                                "div",
                                                {
                                                  ref: "uploadContainer",
                                                  staticClass:
                                                    "upload-container",
                                                  attrs: { tabindex: "0" },
                                                },
                                                [
                                                  _c("Vue2Dropzone", {
                                                    key: "imageUploadDropzone",
                                                    ref: "fileInput",
                                                    attrs: {
                                                      id: "imageUploadDropzone",
                                                      options:
                                                        _vm.dropzoneOptions,
                                                    },
                                                    on: {
                                                      "vdropzone-file-added":
                                                        _vm.onFileAdded,
                                                      "vdropzone-removed-file":
                                                        function ($event) {
                                                          return _vm.setFile(
                                                            false
                                                          )
                                                        },
                                                      "vdropzone-thumbnail":
                                                        _vm.onThumbnailGenerated,
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _vm.isProductComparisonAnalysis()
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "mt-3 rounded border bg-light p-3",
                                                        },
                                                        [
                                                          _c(
                                                            "b-form-checkbox",
                                                            {
                                                              attrs: {
                                                                switch: "",
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.compareWithProductUrl,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.compareWithProductUrl =
                                                                      $$v
                                                                  },
                                                                expression:
                                                                  "compareWithProductUrl",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "font-weight-bold",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Compare with product URL"
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "small",
                                                            {
                                                              staticClass:
                                                                "text-muted d-block mt-1",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                    Compare the uploaded Proposed Assets with the Current PDP images from one product page.\n                  "
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _vm.compareWithProductUrl
                                                            ? _c(
                                                                "b-form-group",
                                                                {
                                                                  staticClass:
                                                                    "mt-3 mb-0",
                                                                  attrs: {
                                                                    label:
                                                                      "Product URL",
                                                                    "label-for":
                                                                      "comparison-product-url",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "b-form-input",
                                                                    {
                                                                      attrs: {
                                                                        id: "comparison-product-url",
                                                                        type: "text",
                                                                        placeholder:
                                                                          "https://www.amazon.com/dp/... or another retailer product URL",
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          _vm.comparisonProductUrl,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.comparisonProductUrl =
                                                                              typeof $$v ===
                                                                              "string"
                                                                                ? $$v.trim()
                                                                                : $$v
                                                                          },
                                                                        expression:
                                                                          "comparisonProductUrl",
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex align-items-start mt-2 flex-wrap",
                                                    },
                                                    [
                                                      !_vm.isProductComparisonAnalysis()
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "d-flex flex-wrap align-items-center gap-2",
                                                            },
                                                            [
                                                              _c(
                                                                "b-dropdown",
                                                                {
                                                                  staticClass:
                                                                    "import-dropdown",
                                                                  attrs: {
                                                                    variant:
                                                                      "outline-secondary",
                                                                  },
                                                                  scopedSlots:
                                                                    _vm._u(
                                                                      [
                                                                        {
                                                                          key: "button-content",
                                                                          fn: function () {
                                                                            return [
                                                                              _c(
                                                                                "b-icon",
                                                                                {
                                                                                  staticClass:
                                                                                    "mr-2",
                                                                                  attrs:
                                                                                    {
                                                                                      icon: "folder2-open",
                                                                                    },
                                                                                }
                                                                              ),
                                                                              _vm._v(
                                                                                "\n                        Import From...\n                      "
                                                                              ),
                                                                            ]
                                                                          },
                                                                          proxy: true,
                                                                        },
                                                                      ],
                                                                      null,
                                                                      false,
                                                                      3488576293
                                                                    ),
                                                                },
                                                                [
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "b-dropdown-item",
                                                                    {
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.openSelectFolderModal(
                                                                              "default"
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "b-icon",
                                                                        {
                                                                          staticClass:
                                                                            "mr-2",
                                                                          attrs:
                                                                            {
                                                                              icon: "folder",
                                                                            },
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        "\n                        File Browser\n                      "
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "b-dropdown-item",
                                                                    {
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.openLayoutModal()
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "b-icon",
                                                                        {
                                                                          staticClass:
                                                                            "mr-2",
                                                                          attrs:
                                                                            {
                                                                              icon: "layout-text-sidebar-reverse",
                                                                            },
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        "\n                        Layouts\n                      "
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "b-dropdown-item",
                                                                    {
                                                                      attrs: {
                                                                        disabled:
                                                                          _vm.isLoading,
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.usePreviousImages(
                                                                              0
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "b-icon",
                                                                        {
                                                                          staticClass:
                                                                            "mr-2",
                                                                          attrs:
                                                                            {
                                                                              icon: "images",
                                                                            },
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        "\n                        Previous Images\n                        "
                                                                      ),
                                                                      _vm.isLoading
                                                                        ? _c(
                                                                            "b-spinner",
                                                                            {
                                                                              staticClass:
                                                                                "ml-2",
                                                                              attrs:
                                                                                {
                                                                                  small:
                                                                                    "",
                                                                                },
                                                                            }
                                                                          )
                                                                        : _vm._e(),
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _vm.isBynderAvailable
                                                                    ? _c(
                                                                        "b-dropdown-item",
                                                                        {
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.openExternalAssetsModal(
                                                                                  "bynder"
                                                                                )
                                                                              },
                                                                          },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "b-icon",
                                                                            {
                                                                              staticClass:
                                                                                "mr-2",
                                                                              attrs:
                                                                                {
                                                                                  icon: "image",
                                                                                },
                                                                            }
                                                                          ),
                                                                          _vm._v(
                                                                            "\n                        Bynder\n                      "
                                                                          ),
                                                                        ],
                                                                        1
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "b-dropdown-item",
                                                                    {
                                                                      attrs: {
                                                                        disabled:
                                                                          _vm.isCapturingScreenshot,
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          _vm.openScreenshotModal,
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "b-icon",
                                                                        {
                                                                          staticClass:
                                                                            "mr-2",
                                                                          attrs:
                                                                            {
                                                                              icon: "camera",
                                                                            },
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        "\n                        Page Screenshot...\n                        "
                                                                      ),
                                                                      _vm.isCapturingScreenshot
                                                                        ? _c(
                                                                            "b-spinner",
                                                                            {
                                                                              staticClass:
                                                                                "ml-2",
                                                                              attrs:
                                                                                {
                                                                                  small:
                                                                                    "",
                                                                                },
                                                                            }
                                                                          )
                                                                        : _vm._e(),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                              _vm._v(" "),
                                                              _vm.uploadedFilesCount >
                                                              0
                                                                ? _c(
                                                                    "b-dropdown",
                                                                    {
                                                                      staticClass:
                                                                        "export-dropdown",
                                                                      attrs: {
                                                                        variant:
                                                                          "outline-secondary",
                                                                      },
                                                                      scopedSlots:
                                                                        _vm._u(
                                                                          [
                                                                            {
                                                                              key: "button-content",
                                                                              fn: function () {
                                                                                return [
                                                                                  _c(
                                                                                    "b-icon",
                                                                                    {
                                                                                      staticClass:
                                                                                        "mr-2",
                                                                                      attrs:
                                                                                        {
                                                                                          icon: "download",
                                                                                        },
                                                                                    }
                                                                                  ),
                                                                                  _vm._v(
                                                                                    "\n                        Export...\n                      "
                                                                                  ),
                                                                                ]
                                                                              },
                                                                              proxy: true,
                                                                            },
                                                                          ],
                                                                          null,
                                                                          false,
                                                                          803601315
                                                                        ),
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "b-dropdown-item",
                                                                        {
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.openSelectFolderModal(
                                                                                  "selectAndCreate"
                                                                                )
                                                                              },
                                                                          },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "b-icon",
                                                                            {
                                                                              staticClass:
                                                                                "mr-2",
                                                                              attrs:
                                                                                {
                                                                                  icon: "file-earmark-image",
                                                                                },
                                                                            }
                                                                          ),
                                                                          _vm._v(
                                                                            "\n                        Save Images to Files\n                      "
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "b-dropdown-item",
                                                                        {
                                                                          directives:
                                                                            [
                                                                              {
                                                                                name: "b-modal",
                                                                                rawName:
                                                                                  "v-b-modal.export-to-layout-modal",
                                                                                modifiers:
                                                                                  {
                                                                                    "export-to-layout-modal": true,
                                                                                  },
                                                                              },
                                                                            ],
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "b-icon",
                                                                            {
                                                                              staticClass:
                                                                                "mr-2",
                                                                              attrs:
                                                                                {
                                                                                  icon: "layout-text-sidebar-reverse",
                                                                                },
                                                                            }
                                                                          ),
                                                                          _vm._v(
                                                                            "\n                        Export Images to Layout\n                      "
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ],
                                                                    1
                                                                  )
                                                                : _vm._e(),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      (_vm.uploadedFilesCount >
                                                        0 ||
                                                        (_vm.manualItemUrl.trim() &&
                                                          !_vm.hasUrlInput)) &&
                                                      !_vm.isImageComparisonAnalysis() &&
                                                      !_vm.isProductComparisonAnalysis() &&
                                                      !_vm.isDimensionsReport()
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "ml-3",
                                                            },
                                                            [
                                                              _c(
                                                                "b-button",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name: "b-toggle",
                                                                      rawName:
                                                                        "v-b-toggle.manual-item-url-collapse",
                                                                      modifiers:
                                                                        {
                                                                          "manual-item-url-collapse": true,
                                                                        },
                                                                    },
                                                                  ],
                                                                  staticClass:
                                                                    "p-0 align-baseline manual-item-url-btn",
                                                                  attrs: {
                                                                    variant:
                                                                      "link",
                                                                    "aria-expanded":
                                                                      _vm.showManualUrl ||
                                                                      _vm.isImageComparisonAnalysis()
                                                                        ? true
                                                                        : false,
                                                                    "aria-controls":
                                                                      "manual-item-url-collapse",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                      " +
                                                                      _vm._s(
                                                                        _vm.isImageComparisonAnalysis()
                                                                          ? "Enter Salsify product ID"
                                                                          : "Optional: Enter ASIN / TCIN / URL for Report"
                                                                      ) +
                                                                      "\n\n                      "
                                                                  ),
                                                                  _vm.isImageComparisonAnalysis()
                                                                    ? _c(
                                                                        "b-icon",
                                                                        {
                                                                          staticClass:
                                                                            "ml-1",
                                                                          attrs:
                                                                            {
                                                                              icon: _vm.showManualUrl
                                                                                ? "chevron-up"
                                                                                : "chevron-down",
                                                                            },
                                                                        }
                                                                      )
                                                                    : _vm._e(),
                                                                ],
                                                                1
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "b-collapse",
                                                                {
                                                                  staticClass:
                                                                    "mt-2",
                                                                  attrs: {
                                                                    id: "manual-item-url-collapse",
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.showManualUrl,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.showManualUrl =
                                                                          $$v
                                                                      },
                                                                    expression:
                                                                      "showManualUrl",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "b-form-group",
                                                                    {
                                                                      staticClass:
                                                                        "mb-0",
                                                                      attrs: {
                                                                        "label-for":
                                                                          "manual-item-url",
                                                                      },
                                                                    },
                                                                    [
                                                                      !_vm.isImageComparisonAnalysis()
                                                                        ? _c(
                                                                            "small",
                                                                            {
                                                                              staticClass:
                                                                                "text-muted d-block mb-2",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                          This will be displayed in the report even when using uploaded images\n                        "
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _vm.manualItemUrl &&
                                                                      _vm.manualItemUrl.includes(
                                                                        "\n"
                                                                      )
                                                                        ? _c(
                                                                            "b-form-textarea",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  id: "manual-item-url",
                                                                                  placeholder:
                                                                                    "Enter ASINs, TCINs, or URLs (separated by spaces or line breaks)",
                                                                                  rows: "4",
                                                                                  trim: "",
                                                                                },
                                                                              model:
                                                                                {
                                                                                  value:
                                                                                    _vm.manualItemUrl,
                                                                                  callback:
                                                                                    function (
                                                                                      $$v
                                                                                    ) {
                                                                                      _vm.manualItemUrl =
                                                                                        $$v
                                                                                    },
                                                                                  expression:
                                                                                    "manualItemUrl",
                                                                                },
                                                                            }
                                                                          )
                                                                        : _c(
                                                                            "b-form-input",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  id: "manual-item-url",
                                                                                  placeholder:
                                                                                    _vm.isImageComparisonAnalysis()
                                                                                      ? "Enter Salsify ID"
                                                                                      : "e.g., B08N5WRWNW or https://www.amazon.com/dp/B08N5WRWNW",
                                                                                  trim: "",
                                                                                },
                                                                              model:
                                                                                {
                                                                                  value:
                                                                                    _vm.manualItemUrl,
                                                                                  callback:
                                                                                    function (
                                                                                      $$v
                                                                                    ) {
                                                                                      _vm.manualItemUrl =
                                                                                        $$v
                                                                                    },
                                                                                  expression:
                                                                                    "manualItemUrl",
                                                                                },
                                                                            }
                                                                          ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.isImageOrderAnalysis() &&
                              !_vm.isImageComparisonAnalysis() &&
                              !_vm.isShopperInsightsReport()
                                ? _c(
                                    "b-tab",
                                    {
                                      attrs: { active: _vm.activeTab === 1 },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "title",
                                            fn: function () {
                                              return [
                                                _c("b-icon", {
                                                  staticClass: "mr-2",
                                                  attrs: { icon: "link-45deg" },
                                                }),
                                                _vm._v(
                                                  "\n              URLs / ASINs\n            "
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        1262817204
                                      ),
                                    },
                                    [
                                      _vm._v(" "),
                                      _vm.isComparisonAnalysis()
                                        ? _c("div", [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "rounded border p-3 mb-3",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex align-items-flex-start gap-2 flex-column",
                                                  },
                                                  [
                                                    _c(
                                                      "b-form-group",
                                                      {
                                                        attrs: {
                                                          label:
                                                            "Enter URLs or Product IDs for comparison",
                                                        },
                                                      },
                                                      [
                                                        _c("b-form-textarea", {
                                                          staticClass:
                                                            "flex-grow-1",
                                                          attrs: {
                                                            placeholder:
                                                              "Enter URLs, ASINs, Walmart IDs, TCINs or Salsify IDs for comparison (separated by spaces or line breaks) ",
                                                            rows: "4",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.comparisonMultipleInput,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.comparisonMultipleInput =
                                                                $$v
                                                            },
                                                            expression:
                                                              "comparisonMultipleInput",
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "use-previous-asin-hint-row form-text text-muted",
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                "You can enter multiple items separated by spaces or line breaks"
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "a",
                                                              {
                                                                staticClass:
                                                                  "use-previous-asin-link",
                                                                class: {
                                                                  "use-previous-asin-link--disabled":
                                                                    _vm.isLoading,
                                                                },
                                                                attrs: {
                                                                  href: "#",
                                                                  "aria-disabled":
                                                                    _vm.isLoading
                                                                      ? "true"
                                                                      : "false",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      $event.preventDefault()
                                                                      return _vm.onUsePreviousAsinClick.apply(
                                                                        null,
                                                                        arguments
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        Use Previous ASIN/URL\n                        "
                                                                ),
                                                                _vm.isLoading
                                                                  ? _c(
                                                                      "b-spinner",
                                                                      {
                                                                        staticClass:
                                                                          "ml-1",
                                                                        attrs: {
                                                                          small:
                                                                            "",
                                                                        },
                                                                      }
                                                                    )
                                                                  : _vm._e(),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ])
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "rounded border p-3 mb-3",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex align-items-flex-start gap-2 flex-column",
                                                },
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        label:
                                                          "Enter URLs or Product IDs",
                                                      },
                                                    },
                                                    [
                                                      _c("b-form-textarea", {
                                                        staticClass:
                                                          "flex-grow-1",
                                                        attrs: {
                                                          placeholder:
                                                            "Enter URLs, ASINs, Walmart IDs, TCINs or Salsify IDs (separated by spaces or line breaks)",
                                                          rows: "4",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.multipleUrlsInput,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.multipleUrlsInput =
                                                              $$v
                                                          },
                                                          expression:
                                                            "multipleUrlsInput",
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "use-previous-asin-hint-row form-text text-muted",
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              "You can enter multiple items separated by spaces or line breaks"
                                                            ),
                                                          ]),
                                                          _vm._v(" "),
                                                          _c(
                                                            "a",
                                                            {
                                                              staticClass:
                                                                "use-previous-asin-link",
                                                              class: {
                                                                "use-previous-asin-link--disabled":
                                                                  _vm.isLoading,
                                                              },
                                                              attrs: {
                                                                href: "#",
                                                                "aria-disabled":
                                                                  _vm.isLoading
                                                                    ? "true"
                                                                    : "false",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.preventDefault()
                                                                    return _vm.onUsePreviousAsinClick.apply(
                                                                      null,
                                                                      arguments
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                      Use Previous ASIN/URL\n                      "
                                                              ),
                                                              _vm.isLoading
                                                                ? _c(
                                                                    "b-spinner",
                                                                    {
                                                                      staticClass:
                                                                        "ml-1",
                                                                      attrs: {
                                                                        small:
                                                                          "",
                                                                      },
                                                                    }
                                                                  )
                                                                : _vm._e(),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _vm.hasMultipleUrls &&
                                              _vm.canManageGroups
                                                ? _c(
                                                    "div",
                                                    { staticClass: "mt-3" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "d-flex align-items-center gap-2",
                                                        },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "mb-0",
                                                              staticStyle: {
                                                                "min-width":
                                                                  "150px",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                    Add to Group:\n                  "
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          !_vm.createNewGroup
                                                            ? _c(
                                                                "Multiselect",
                                                                {
                                                                  staticClass:
                                                                    "flex-grow-1",
                                                                  attrs: {
                                                                    "track-by":
                                                                      "id",
                                                                    label:
                                                                      "name",
                                                                    "custom-label":
                                                                      _vm.groupNameWithReportsCount,
                                                                    options:
                                                                      _vm.availableGroups,
                                                                    disabled:
                                                                      _vm.isLoadingGroups,
                                                                    placeholder:
                                                                      "Select a group (optional)",
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.selectedGroupObj,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.selectedGroupObj =
                                                                          $$v
                                                                      },
                                                                    expression:
                                                                      "selectedGroupObj",
                                                                  },
                                                                }
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _vm.createNewGroup
                                                            ? _c(
                                                                "b-form-input",
                                                                {
                                                                  staticClass:
                                                                    "flex-grow-1",
                                                                  attrs: {
                                                                    placeholder:
                                                                      "Enter new group name",
                                                                    state:
                                                                      _vm
                                                                        .newGroupName
                                                                        .length >
                                                                        0 &&
                                                                      _vm
                                                                        .newGroupName
                                                                        .length <=
                                                                        255
                                                                        ? true
                                                                        : null,
                                                                    size: "sm",
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.newGroupName,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.newGroupName =
                                                                          $$v
                                                                      },
                                                                    expression:
                                                                      "newGroupName",
                                                                  },
                                                                }
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _c(
                                                            "b-button",
                                                            {
                                                              staticClass:
                                                                "text-nowrap",
                                                              attrs: {
                                                                variant: "link",
                                                                size: "sm",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    _vm.createNewGroup =
                                                                      !_vm.createNewGroup
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                    " +
                                                                  _vm._s(
                                                                    _vm.createNewGroup
                                                                      ? "Select existing"
                                                                      : "Create new"
                                                                  ) +
                                                                  "\n                  "
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "text-muted d-block mt-1",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                  " +
                                                              _vm._s(
                                                                _vm.urls.length
                                                              ) +
                                                              " URLs detected. Each will create a separate report" +
                                                              _vm._s(
                                                                _vm.selectedGroupId ||
                                                                  (_vm.createNewGroup &&
                                                                    _vm.newGroupName)
                                                                  ? " and be added to the group"
                                                                  : ""
                                                              ) +
                                                              ".\n                "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.isShopperInsightsReport() &&
                              !_vm.isDimensionsReport()
                                ? _c(
                                    "b-tab",
                                    {
                                      attrs: { active: _vm.activeTab === 2 },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "title",
                                            fn: function () {
                                              return [
                                                _c("b-icon", {
                                                  staticClass: "mr-2",
                                                  attrs: { icon: "list-ul" },
                                                }),
                                                _vm._v(
                                                  "\n              " +
                                                    _vm._s(
                                                      _vm.isImageComparisonAnalysis()
                                                        ? "Step 1: Select a product from a product List"
                                                        : "Product Lists"
                                                    ) +
                                                    "\n            "
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        1295047833
                                      ),
                                    },
                                    [
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "rounded border p-3 mb-3 bg-light",
                                        },
                                        [
                                          _c("div", { staticClass: "row" }, [
                                            _c(
                                              "div",
                                              { staticClass: "col-md-6 mt-1" },
                                              [
                                                _c(
                                                  "b-form-group",
                                                  {
                                                    attrs: {
                                                      label:
                                                        "Select Product Lists",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "Multiselect",
                                                      {
                                                        attrs: {
                                                          options:
                                                            _vm.availableProductLists,
                                                          multiple: true,
                                                          searchable: true,
                                                          disabled:
                                                            _vm.isLoadingProductLists,
                                                          loading:
                                                            _vm.isLoadingProductLists,
                                                          "track-by": "id",
                                                          label: "name",
                                                          placeholder:
                                                            "Select product lists",
                                                          "allow-empty": true,
                                                        },
                                                        on: {
                                                          input:
                                                            _vm.loadProductsFromLists,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.selectedProductLists,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.selectedProductLists =
                                                              $$v
                                                          },
                                                          expression:
                                                            "selectedProductLists",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "template",
                                                          { slot: "noResult" },
                                                          [
                                                            _vm._v(
                                                              "\n                        No product lists found\n                      "
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      2
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.isLoadingProductLists
                                                      ? _c(
                                                          "small",
                                                          {
                                                            staticClass:
                                                              "text-info",
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fas fa-spinner fa-spin",
                                                            }),
                                                            _vm._v(
                                                              " Loading lists...\n                    "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _vm.availableProducts.length > 0
                                              ? _c(
                                                  "div",
                                                  { staticClass: "col-md-6" },
                                                  [
                                                    _c(
                                                      "b-form-group",
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "d-flex justify-content-between align-items-center",
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                "\n                        Select Individual Products:\n                      "
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "w-25 mb-1",
                                                              },
                                                              [
                                                                _c(
                                                                  "b-form-select",
                                                                  {
                                                                    attrs: {
                                                                      options:
                                                                        _vm.availableColumnFilters,
                                                                      size: "sm",
                                                                      "value-field":
                                                                        "value",
                                                                      "text-field":
                                                                        "text",
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm.selectedColumnFilter,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.selectedColumnFilter =
                                                                            $$v
                                                                        },
                                                                      expression:
                                                                        "selectedColumnFilter",
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "Multiselect",
                                                          {
                                                            attrs: {
                                                              options:
                                                                _vm.filteredProducts,
                                                              multiple: true,
                                                              searchable: true,
                                                              disabled:
                                                                _vm.isLoadingProducts,
                                                              loading:
                                                                _vm.isLoadingProducts,
                                                              "close-on-select": false,
                                                              "track-by": "id",
                                                              label:
                                                                "display_name",
                                                              placeholder:
                                                                "Select specific products",
                                                              "allow-empty": true,
                                                              limit: 3,
                                                              "limit-text":
                                                                _vm.limitText,
                                                              "max-height": 300,
                                                            },
                                                            on: {
                                                              input:
                                                                _vm.populateSelectedProducts,
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "option",
                                                                  fn: function (
                                                                    props
                                                                  ) {
                                                                    return [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "multiselect-option",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "strong",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  props
                                                                                    .option
                                                                                    .display_name
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "small",
                                                                            {
                                                                              staticClass:
                                                                                "text-muted d-block",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  props
                                                                                    .option
                                                                                    .product_list_name
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              false,
                                                              2136968834
                                                            ),
                                                            model: {
                                                              value:
                                                                _vm.selectedProducts,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.selectedProducts =
                                                                    $$v
                                                                },
                                                              expression:
                                                                "selectedProducts",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(" "),
                                                            _c(
                                                              "template",
                                                              {
                                                                slot: "noResult",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        No products found\n                      "
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          2
                                                        ),
                                                        _vm._v(" "),
                                                        _vm.isLoadingProducts
                                                          ? _c(
                                                              "small",
                                                              {
                                                                staticClass:
                                                                  "text-info",
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "fas fa-spinner fa-spin",
                                                                }),
                                                                _vm._v(
                                                                  " Loading products...\n                    "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "mt-2",
                                                          },
                                                          [
                                                            !_vm.isImageComparisonAnalysis()
                                                              ? _c(
                                                                  "b-button",
                                                                  {
                                                                    staticClass:
                                                                      "mr-2",
                                                                    attrs: {
                                                                      variant:
                                                                        _vm
                                                                          .selectedProducts
                                                                          .length ===
                                                                        _vm
                                                                          .filteredProducts
                                                                          .length
                                                                          ? "primary"
                                                                          : "outline-primary",
                                                                      size: "sm",
                                                                      disabled:
                                                                        _vm.isLoadingProducts ||
                                                                        _vm
                                                                          .filteredProducts
                                                                          .length ===
                                                                          0,
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        _vm.selectAll,
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "b-icon",
                                                                      {
                                                                        attrs: {
                                                                          icon:
                                                                            _vm
                                                                              .selectedProducts
                                                                              .length ===
                                                                            _vm
                                                                              .filteredProducts
                                                                              .length
                                                                              ? "check-square"
                                                                              : "square",
                                                                        },
                                                                      }
                                                                    ),
                                                                    _vm._v(
                                                                      " Select All\n                      "
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            _vm.selectedProducts
                                                              .length > 0
                                                              ? _c(
                                                                  "b-button",
                                                                  {
                                                                    attrs: {
                                                                      variant:
                                                                        "outline-danger",
                                                                      size: "sm",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        _vm.clearAll,
                                                                    },
                                                                  },
                                                                  [
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "fas fa-times",
                                                                    }),
                                                                    _vm._v(
                                                                      " Clear All\n                      "
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isShopperInsightsReport()
                        ? _c("div", [
                            _c(
                              "form",
                              { attrs: { id: "ShopperInsightsForm" } },
                              [
                                _c("div", { staticClass: "mb-3" }, [
                                  _c("label", { staticClass: "form-label" }, [
                                    _vm._v("Brand name"),
                                  ]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.shopperInsightsFormValues
                                            .brand_name,
                                        expression:
                                          "shopperInsightsFormValues.brand_name",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      type: "text",
                                      name: "brand_name",
                                      required: "",
                                    },
                                    domProps: {
                                      value:
                                        _vm.shopperInsightsFormValues
                                          .brand_name,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.shopperInsightsFormValues,
                                          "brand_name",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "mb-3" }, [
                                  _c("label", { staticClass: "form-label" }, [
                                    _vm._v("Market"),
                                  ]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.shopperInsightsFormValues.market,
                                        expression:
                                          "shopperInsightsFormValues.market",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      type: "text",
                                      name: "market",
                                      required: "",
                                    },
                                    domProps: {
                                      value:
                                        _vm.shopperInsightsFormValues.market,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.shopperInsightsFormValues,
                                          "market",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "form-text text-muted" },
                                    [
                                      _vm._v(
                                        "\n                country/region\n              "
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "mb-3" }, [
                                  _c("label", { staticClass: "form-label" }, [
                                    _vm._v("Category"),
                                  ]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.shopperInsightsFormValues
                                            .category,
                                        expression:
                                          "shopperInsightsFormValues.category",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      type: "text",
                                      name: "category",
                                      required: "",
                                    },
                                    domProps: {
                                      value:
                                        _vm.shopperInsightsFormValues.category,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.shopperInsightsFormValues,
                                          "category",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "mb-3" }, [
                                  _c("label", { staticClass: "form-label" }, [
                                    _vm._v(
                                      "Key product or product lines (if relevant)"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("textarea", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.shopperInsightsFormValues
                                            .product_lines,
                                        expression:
                                          "shopperInsightsFormValues.product_lines",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      name: "product_lines",
                                      rows: "2",
                                      required: "",
                                    },
                                    domProps: {
                                      value:
                                        _vm.shopperInsightsFormValues
                                          .product_lines,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.shopperInsightsFormValues,
                                          "product_lines",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "mb-3" }, [
                                  _c("label", { staticClass: "form-label" }, [
                                    _vm._v("Objective"),
                                  ]),
                                  _vm._v(" "),
                                  _c("textarea", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.shopperInsightsFormValues
                                            .objective,
                                        expression:
                                          "shopperInsightsFormValues.objective",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      name: "objective",
                                      rows: "3",
                                      required: "",
                                    },
                                    domProps: {
                                      value:
                                        _vm.shopperInsightsFormValues.objective,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.shopperInsightsFormValues,
                                          "objective",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "form-text text-muted" },
                                    [
                                      _vm._v(
                                        "\n                Clarify the primary goal (e.g., Premiumization, Support price increase, Improve conversion rate, Differentiate in category, Launch new product, Market expansion).\n              "
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "mb-3" }, [
                                  _c("label", { staticClass: "form-label" }, [
                                    _vm._v("Competitors"),
                                  ]),
                                  _vm._v(" "),
                                  _c("textarea", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.shopperInsightsFormValues
                                            .competitors,
                                        expression:
                                          "shopperInsightsFormValues.competitors",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: { name: "competitors", rows: "2" },
                                    domProps: {
                                      value:
                                        _vm.shopperInsightsFormValues
                                          .competitors,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.shopperInsightsFormValues,
                                          "competitors",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "form-text text-muted" },
                                    [
                                      _vm._v(
                                        "\n                Known competitors\n              "
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "mb-3" }, [
                                  _c("label", { staticClass: "form-label" }, [
                                    _vm._v("Adjacent Categories"),
                                  ]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.shopperInsightsFormValues
                                            .adjacent_categories,
                                        expression:
                                          "shopperInsightsFormValues.adjacent_categories",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      type: "text",
                                      name: "adjacent_categories",
                                      required: "",
                                    },
                                    domProps: {
                                      value:
                                        _vm.shopperInsightsFormValues
                                          .adjacent_categories,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.shopperInsightsFormValues,
                                          "adjacent_categories",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "mb-3" }, [
                                  _c("label", { staticClass: "form-label" }, [
                                    _vm._v("Current Situation"),
                                  ]),
                                  _vm._v(" "),
                                  _c("textarea", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.shopperInsightsFormValues
                                            .current_situation,
                                        expression:
                                          "shopperInsightsFormValues.current_situation",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      name: "current_situation",
                                      rows: "4",
                                      required: "",
                                    },
                                    domProps: {
                                      value:
                                        _vm.shopperInsightsFormValues
                                          .current_situation,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.shopperInsightsFormValues,
                                          "current_situation",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "form-text text-muted" },
                                    [
                                      _vm._v(
                                        '\n                What is currently not working? Do you have data from Ask Rufus or platform AI assistants to identify specific "Category Friction"? Any constraints (brand guidelines, assets, etc.)?\n              '
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isVisualPlayBookAnalysis() &&
                      !(_vm.isImageComparisonAnalysis() && _vm.activeTab === 1)
                        ? _c(
                            "div",
                            { staticClass: "right-panel-footer mt-3" },
                            [
                              !_vm.isDimensionsReport()
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex align-items-center mb-3",
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "bi bi-people mr-2",
                                        staticStyle: {
                                          "font-size": "1.25rem",
                                          color: "#6c757d",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex-grow-1 audience-multiselect-wrapper",
                                        },
                                        [
                                          _c("Multiselect", {
                                            attrs: {
                                              options: _vm.audiences,
                                              multiple: true,
                                              searchable: true,
                                              loading: _vm.isLoadingAudiences,
                                              disabled: _vm.isLoadingAudiences,
                                              "track-by": "id",
                                              label: "name",
                                              placeholder: "Choose audience...",
                                              "close-on-select": false,
                                              "allow-empty": true,
                                              "open-direction": "auto",
                                            },
                                            model: {
                                              value: _vm.selectedAudiences,
                                              callback: function ($$v) {
                                                _vm.selectedAudiences = $$v
                                              },
                                              expression: "selectedAudiences",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-button",
                                        {
                                          staticClass:
                                            "ml-2 btn-group-style h-fit",
                                          attrs: {
                                            variant: "outline-secondary",
                                            size: "md",
                                          },
                                          on: {
                                            click: _vm.openNewAudienceModal,
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "bi bi-plus-circle mr-1",
                                          }),
                                          _vm._v(
                                            "\n              New Audience\n            "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-items-center ml-3",
                                          staticStyle: { "min-width": "280px" },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "bi bi-shop mr-2",
                                            staticStyle: {
                                              "font-size": "1.1rem",
                                              color: "#6c757d",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.selectedRetailerPrompt,
                                                  expression:
                                                    "selectedRetailerPrompt",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              staticStyle: {
                                                height: "45px",
                                                "border-color": "#dee2e6",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  var $$selectedVal =
                                                    Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function (o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function (o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                  _vm.selectedRetailerPrompt =
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "option",
                                                { domProps: { value: null } },
                                                [
                                                  _vm._v(
                                                    "\n                  Retailer (optional)\n                "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.retailerList,
                                                function (retailer) {
                                                  return _c(
                                                    "option",
                                                    {
                                                      key: retailer.value,
                                                      domProps: {
                                                        value: retailer.value,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                  " +
                                                          _vm._s(
                                                            retailer.label
                                                          ) +
                                                          "\n                "
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                            ],
                                            2
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.promptContainsAudience
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex align-items-center mb-3",
                                      staticStyle: {
                                        "font-size": "0.875rem",
                                        color: "#6c757d",
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "bi bi-info-circle",
                                        staticStyle: {
                                          "margin-right": "6px",
                                          "font-size": "1rem",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          "This analysis works best with an audience selected"
                                        ),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.isDimensionsReport()
                                ? _c("div", { staticClass: "row mb-3" }, [
                                    _c("div", { staticClass: "col-md-6" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-items-center",
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "bi bi-palette mr-2",
                                            staticStyle: {
                                              "font-size": "1.15rem",
                                              color: "#6c757d",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex-grow-1 audience-multiselect-wrapper",
                                            },
                                            [
                                              _c("Multiselect", {
                                                attrs: {
                                                  options: _vm.brandGuidelines,
                                                  multiple: true,
                                                  searchable: true,
                                                  loading:
                                                    _vm.isLoadingBrandGuidelines,
                                                  disabled:
                                                    _vm.isLoadingBrandGuidelines,
                                                  "track-by": "id",
                                                  label: "brand_name",
                                                  placeholder:
                                                    "Choose brand guidelines...",
                                                  "close-on-select": false,
                                                  "allow-empty": true,
                                                  "open-direction": "auto",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "option",
                                                      fn: function (props) {
                                                        return [
                                                          _c("div", [
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  props.option
                                                                    .brand_name
                                                                )
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            props.option
                                                              .voice ||
                                                            props.option
                                                              .visual_style
                                                              ? _c(
                                                                  "small",
                                                                  {
                                                                    staticClass:
                                                                      "text-muted d-block",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                          " +
                                                                        _vm._s(
                                                                          [
                                                                            props
                                                                              .option
                                                                              .voice,
                                                                            props
                                                                              .option
                                                                              .visual_style,
                                                                          ]
                                                                            .filter(
                                                                              Boolean
                                                                            )
                                                                            .join(
                                                                              " · "
                                                                            )
                                                                        ) +
                                                                        "\n                        "
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  false,
                                                  3319008877
                                                ),
                                                model: {
                                                  value:
                                                    _vm.selectedBrandGuidelines,
                                                  callback: function ($$v) {
                                                    _vm.selectedBrandGuidelines =
                                                      $$v
                                                  },
                                                  expression:
                                                    "selectedBrandGuidelines",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-button",
                                            {
                                              staticClass:
                                                "ml-2 btn-group-style h-fit",
                                              attrs: {
                                                variant: "outline-secondary",
                                                size: "md",
                                              },
                                              on: {
                                                click:
                                                  _vm.openNewBrandGuideline,
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "bi bi-plus-circle mr-1",
                                              }),
                                              _vm._v(
                                                "\n                  New\n                "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-md-6" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-items-center",
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "bi bi-calendar-event mr-2",
                                            staticStyle: {
                                              "font-size": "1.15rem",
                                              color: "#6c757d",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex-grow-1 audience-multiselect-wrapper",
                                            },
                                            [
                                              _c("Multiselect", {
                                                attrs: {
                                                  options: _vm.seasonalities,
                                                  multiple: true,
                                                  searchable: true,
                                                  loading:
                                                    _vm.isLoadingSeasonalities,
                                                  disabled:
                                                    _vm.isLoadingSeasonalities,
                                                  "track-by": "id",
                                                  label: "name",
                                                  placeholder:
                                                    "Choose seasonality...",
                                                  "close-on-select": false,
                                                  "allow-empty": true,
                                                  "open-direction": "auto",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "option",
                                                      fn: function (props) {
                                                        return [
                                                          _c("div", [
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  props.option
                                                                    .name
                                                                )
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            props.option
                                                              .description
                                                              ? _c(
                                                                  "small",
                                                                  {
                                                                    staticClass:
                                                                      "text-muted d-block",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                          " +
                                                                        _vm._s(
                                                                          props
                                                                            .option
                                                                            .description
                                                                        ) +
                                                                        "\n                        "
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  false,
                                                  551238866
                                                ),
                                                model: {
                                                  value:
                                                    _vm.selectedSeasonalities,
                                                  callback: function ($$v) {
                                                    _vm.selectedSeasonalities =
                                                      $$v
                                                  },
                                                  expression:
                                                    "selectedSeasonalities",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-button",
                                            {
                                              staticClass:
                                                "ml-2 btn-group-style h-fit",
                                              attrs: {
                                                variant: "outline-secondary",
                                                size: "md",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  _vm.showSeasonalityModal = true
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "bi bi-plus-circle mr-1",
                                              }),
                                              _vm._v(
                                                "\n                  New\n                "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("SeasonalityModal", {
                                attrs: { show: _vm.showSeasonalityModal },
                                on: {
                                  "update:show": function ($event) {
                                    _vm.showSeasonalityModal = $event
                                  },
                                  created: _vm.onSeasonalityCreated,
                                },
                              }),
                              _vm._v(" "),
                              _vm.selectedPromptEditableTables.length
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "editable-prompt-fields-card rounded border bg-light mb-3",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-content-between align-items-center p-3 cursor-pointer",
                                          attrs: { role: "button" },
                                          on: {
                                            click: function ($event) {
                                              _vm.editableKpiSettingsExpanded =
                                                !_vm.editableKpiSettingsExpanded
                                            },
                                          },
                                        },
                                        [
                                          _vm._m(3),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-items-center",
                                            },
                                            [
                                              _vm.selectedPromptEditableTables
                                                .length
                                                ? _c(
                                                    "b-badge",
                                                    {
                                                      staticClass: "mr-2",
                                                      attrs: {
                                                        variant: "secondary",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                  " +
                                                          _vm._s(
                                                            _vm
                                                              .selectedPromptEditableTables
                                                              .length
                                                          ) +
                                                          "\n                  " +
                                                          _vm._s(
                                                            _vm
                                                              .selectedPromptEditableTables
                                                              .length === 1
                                                              ? "block"
                                                              : "blocks"
                                                          ) +
                                                          "\n                "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("i", {
                                                staticClass: "fas",
                                                class:
                                                  _vm.editableKpiSettingsExpanded
                                                    ? "fa-chevron-up"
                                                    : "fa-chevron-down",
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-collapse",
                                        {
                                          model: {
                                            value:
                                              _vm.editableKpiSettingsExpanded,
                                            callback: function ($$v) {
                                              _vm.editableKpiSettingsExpanded =
                                                $$v
                                            },
                                            expression:
                                              "editableKpiSettingsExpanded",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "px-3 pb-3" },
                                            _vm._l(
                                              _vm.selectedPromptEditableTables,
                                              function (table, tableIndex) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: `editable-kpi-block-${tableIndex}`,
                                                    staticClass:
                                                      "editable-kpi-table-card rounded border bg-white p-3 mb-3",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "d-flex justify-content-between align-items-center mb-3",
                                                      },
                                                      [
                                                        _c("div", [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "font-weight-bold",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    table.label
                                                                  ) +
                                                                  "\n                      "
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "small",
                                                            {
                                                              staticClass:
                                                                "text-muted",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    table.type ===
                                                                      "kpi_list"
                                                                      ? "KPI Items"
                                                                      : "KPI Table"
                                                                  ) +
                                                                  "\n                      "
                                                              ),
                                                            ]
                                                          ),
                                                        ]),
                                                        _vm._v(" "),
                                                        _c(
                                                          "b-badge",
                                                          {
                                                            attrs: {
                                                              variant:
                                                                _vm.getEditableTableKpiTotal(
                                                                  table
                                                                ) === 100
                                                                  ? "success"
                                                                  : _vm.getEditableTableKpiTotal(
                                                                      table
                                                                    ) > 100
                                                                  ? "danger"
                                                                  : "warning",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                      Total: " +
                                                                _vm._s(
                                                                  _vm.getEditableTableKpiTotal(
                                                                    table
                                                                  )
                                                                ) +
                                                                "%\n                    "
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    table.type === "kpi_list"
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass: "mb-3",
                                                          },
                                                          [
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "small text-muted mb-1",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                      KPI title / intro text\n                    "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "b-form-textarea",
                                                              {
                                                                attrs: {
                                                                  rows: "3",
                                                                  size: "sm",
                                                                  placeholder:
                                                                    "Example: An evaluation of each image in the Evaluation & Recommendations separate column using the following weighted criteria...",
                                                                },
                                                                model: {
                                                                  value:
                                                                    table.intro,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        table,
                                                                        "intro",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "table.intro",
                                                                },
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm._l(
                                                      table.kpis,
                                                      function (kpi, index) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key: `editable-kpi-${tableIndex}-${index}`,
                                                            staticClass:
                                                              "editable-kpi-row mb-2",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "row align-items-start",
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "col-md-3",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "label",
                                                                      {
                                                                        staticClass:
                                                                          "small text-muted mb-1",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "KPI name"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "b-form-input",
                                                                      {
                                                                        attrs: {
                                                                          size: "sm",
                                                                          placeholder:
                                                                            "KPI name",
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            kpi.name,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                kpi,
                                                                                "name",
                                                                                $$v
                                                                              )
                                                                            },
                                                                          expression:
                                                                            "kpi.name",
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "col-md-2",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "label",
                                                                      {
                                                                        staticClass:
                                                                          "small text-muted mb-1",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Weight"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "b-input-group",
                                                                      {
                                                                        attrs: {
                                                                          size: "sm",
                                                                          append:
                                                                            "%",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "b-form-input",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                type: "number",
                                                                                min: "0",
                                                                                max: "100",
                                                                                placeholder:
                                                                                  "0",
                                                                              },
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  kpi.weight,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      kpi,
                                                                                      "weight",
                                                                                      _vm._n(
                                                                                        $$v
                                                                                      )
                                                                                    )
                                                                                  },
                                                                                expression:
                                                                                  "kpi.weight",
                                                                              },
                                                                          }
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "col-md-6",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "label",
                                                                      {
                                                                        staticClass:
                                                                          "small text-muted mb-1",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Evaluation"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "b-form-textarea",
                                                                      {
                                                                        attrs: {
                                                                          rows: "2",
                                                                          size: "sm",
                                                                          placeholder:
                                                                            "Evaluation instruction",
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            kpi.evaluation,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                kpi,
                                                                                "evaluation",
                                                                                $$v
                                                                              )
                                                                            },
                                                                          expression:
                                                                            "kpi.evaluation",
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "col-md-1 text-right pt-4",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "b-button",
                                                                      {
                                                                        attrs: {
                                                                          variant:
                                                                            "outline-danger",
                                                                          size: "sm",
                                                                          title:
                                                                            "Remove KPI",
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              $event.stopPropagation()
                                                                              return _vm.removeEditableTableKpi(
                                                                                tableIndex,
                                                                                index
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "i",
                                                                          {
                                                                            staticClass:
                                                                              "fas fa-trash",
                                                                          }
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "text-right mt-2",
                                                      },
                                                      [
                                                        _c(
                                                          "b-button",
                                                          {
                                                            attrs: {
                                                              variant:
                                                                "outline-primary",
                                                              size: "sm",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                return _vm.addEditableTableKpi(
                                                                  tableIndex
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fas fa-plus mr-1",
                                                            }),
                                                            _vm._v(
                                                              "\n                      Add KPI\n                    "
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  2
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.uploadedFilesCount > 0 &&
                              !_vm.isDimensionsReport()
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "image-type-labels-settings mb-2",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "advanced-toggle mb-2",
                                          on: {
                                            click: function ($event) {
                                              _vm.isImageTypeLabelsOpen =
                                                !_vm.isImageTypeLabelsOpen
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fas fa-chevron-down mr-2",
                                            class: {
                                              "rotate-icon":
                                                _vm.isImageTypeLabelsOpen,
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v("Image type labels"),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "b-badge",
                                            {
                                              staticClass: "ml-2",
                                              attrs: { variant: "secondary" },
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.uploadedFilesCount
                                                  ) +
                                                  "\n              "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-collapse",
                                        {
                                          staticClass: "advanced-content mb-3",
                                          model: {
                                            value: _vm.isImageTypeLabelsOpen,
                                            callback: function ($$v) {
                                              _vm.isImageTypeLabelsOpen = $$v
                                            },
                                            expression: "isImageTypeLabelsOpen",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "advanced-panel p-3 border rounded bg-light",
                                            },
                                            [
                                              _c(
                                                "small",
                                                {
                                                  staticClass:
                                                    "text-muted d-block mb-3",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  Optionally label each uploaded image, e.g. Hero, Lifestyle, Nutrition, Ingredients, Pack Shot.\n                "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.uploadedImageFiles,
                                                function (uploadedFile, index) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: _vm.getImageTypeLabelKey(
                                                        uploadedFile,
                                                        index
                                                      ),
                                                      staticClass:
                                                        "image-type-label-row d-flex align-items-center mb-2",
                                                      staticStyle: {
                                                        gap: "10px",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "image-type-label-number text-muted text-center",
                                                          staticStyle: {
                                                            width: "70px",
                                                            "font-size": "13px",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                    Image " +
                                                              _vm._s(
                                                                index + 1
                                                              ) +
                                                              "\n                  "
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "image-type-label-thumb rounded border bg-white d-flex align-items-center justify-content-center overflow-hidden",
                                                          staticStyle: {
                                                            width: "44px",
                                                            height: "44px",
                                                            flex: "0 0 44px",
                                                          },
                                                        },
                                                        [
                                                          uploadedFile.dataURL
                                                            ? _c("img", {
                                                                staticStyle: {
                                                                  width: "100%",
                                                                  height:
                                                                    "100%",
                                                                  "object-fit":
                                                                    "cover",
                                                                },
                                                                attrs: {
                                                                  src: uploadedFile.dataURL,
                                                                  alt: `Image ${
                                                                    index + 1
                                                                  }`,
                                                                },
                                                              })
                                                            : _c("i", {
                                                                staticClass:
                                                                  "bi bi-image text-muted",
                                                              }),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          size: "sm",
                                                          placeholder:
                                                            "e.g., Hero, Lifestyle, Nutrition, Ingredients, Pack Shot",
                                                          trim: "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.imageTypeLabels[
                                                              _vm.getImageTypeLabelKey(
                                                                uploadedFile,
                                                                index
                                                              )
                                                            ],
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.imageTypeLabels,
                                                              _vm.getImageTypeLabelKey(
                                                                uploadedFile,
                                                                index
                                                              ),
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "imageTypeLabels[getImageTypeLabelKey(uploadedFile, index)]",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                            ],
                                            2
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "advanced-toggle mb-2",
                                  on: {
                                    click: function ($event) {
                                      _vm.isAdvancedOpen = !_vm.isAdvancedOpen
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fas fa-chevron-down mr-2",
                                    class: {
                                      "rotate-icon": _vm.isAdvancedOpen,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Advanced")]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-collapse",
                                {
                                  staticClass: "advanced-content mb-3",
                                  model: {
                                    value: _vm.isAdvancedOpen,
                                    callback: function ($$v) {
                                      _vm.isAdvancedOpen = $$v
                                    },
                                    expression: "isAdvancedOpen",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "advanced-panel p-3 border rounded bg-light",
                                    },
                                    [
                                      _vm.previousReports.length > 0
                                        ? _c("div", { staticClass: "mb-2" }, [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-link p-0 text-decoration-none",
                                                on: {
                                                  click:
                                                    _vm.openPreviousReportModal,
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "bi bi-file-earmark-text mr-2",
                                                }),
                                                _vm._v(
                                                  "\n                  Incorporate previous report\n                  "
                                                ),
                                                _vm.selectedPreviousReportId
                                                  ? _c("i", {
                                                      staticClass:
                                                        "bi bi-check-circle-fill text-success ml-1",
                                                    })
                                                  : _vm._e(),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("hr", { staticClass: "my-2" }),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "mb-2" }, [
                                        _c(
                                          "label",
                                          {
                                            staticClass: "form-label mb-1",
                                            staticStyle: {
                                              "font-size": "14px",
                                            },
                                            attrs: {
                                              for: "customer_name_input_panel",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  Customer name\n                "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.customerName,
                                              expression: "customerName",
                                            },
                                          ],
                                          staticClass:
                                            "form-control form-control-sm",
                                          attrs: {
                                            id: "customer_name_input_panel",
                                            type: "text",
                                            placeholder: "e.g., PepsiCo",
                                          },
                                          domProps: { value: _vm.customerName },
                                          on: {
                                            blur: _vm.saveCustomerName,
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.customerName =
                                                $event.target.value
                                            },
                                          },
                                        }),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "form-check mb-1" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.isBackgroundJob,
                                                expression: "isBackgroundJob",
                                              },
                                            ],
                                            staticClass: "form-check-input",
                                            attrs: {
                                              id: "background_job_optix_panel",
                                              type: "checkbox",
                                            },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.isBackgroundJob
                                              )
                                                ? _vm._i(
                                                    _vm.isBackgroundJob,
                                                    null
                                                  ) > -1
                                                : _vm.isBackgroundJob,
                                            },
                                            on: {
                                              change: function ($event) {
                                                var $$a = _vm.isBackgroundJob,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      (_vm.isBackgroundJob =
                                                        $$a.concat([$$v]))
                                                  } else {
                                                    $$i > -1 &&
                                                      (_vm.isBackgroundJob = $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        ))
                                                  }
                                                } else {
                                                  _vm.isBackgroundJob = $$c
                                                }
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "cursor-pointer mb-1",
                                              attrs: {
                                                for: "background_job_optix_panel",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  Run in background\n                "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "form-check mb-1" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.useDomainAsClientName,
                                                expression:
                                                  "useDomainAsClientName",
                                              },
                                            ],
                                            staticClass: "form-check-input",
                                            attrs: {
                                              id: "use_domain_as_client_name_panel",
                                              type: "checkbox",
                                            },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.useDomainAsClientName
                                              )
                                                ? _vm._i(
                                                    _vm.useDomainAsClientName,
                                                    null
                                                  ) > -1
                                                : _vm.useDomainAsClientName,
                                            },
                                            on: {
                                              change: function ($event) {
                                                var $$a =
                                                    _vm.useDomainAsClientName,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      (_vm.useDomainAsClientName =
                                                        $$a.concat([$$v]))
                                                  } else {
                                                    $$i > -1 &&
                                                      (_vm.useDomainAsClientName =
                                                        $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          ))
                                                  }
                                                } else {
                                                  _vm.useDomainAsClientName =
                                                    $$c
                                                }
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "cursor-pointer mb-1",
                                              attrs: {
                                                for: "use_domain_as_client_name_panel",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  Use Domain as Customer Name\n                "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "form-check mb-1" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.isReduceImageQuality,
                                                expression:
                                                  "isReduceImageQuality",
                                              },
                                            ],
                                            staticClass: "form-check-input",
                                            attrs: {
                                              id: "reduce_image_quality_panel",
                                              type: "checkbox",
                                            },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.isReduceImageQuality
                                              )
                                                ? _vm._i(
                                                    _vm.isReduceImageQuality,
                                                    null
                                                  ) > -1
                                                : _vm.isReduceImageQuality,
                                            },
                                            on: {
                                              change: function ($event) {
                                                var $$a =
                                                    _vm.isReduceImageQuality,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      (_vm.isReduceImageQuality =
                                                        $$a.concat([$$v]))
                                                  } else {
                                                    $$i > -1 &&
                                                      (_vm.isReduceImageQuality =
                                                        $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          ))
                                                  }
                                                } else {
                                                  _vm.isReduceImageQuality = $$c
                                                }
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "cursor-pointer mb-1",
                                              attrs: {
                                                for: "reduce_image_quality_panel",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  Use scaled images\n                "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "form-check mb-1" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.isSaveSettings,
                                                expression: "isSaveSettings",
                                              },
                                            ],
                                            staticClass: "form-check-input",
                                            attrs: {
                                              id: "save_settings_panel",
                                              type: "checkbox",
                                            },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.isSaveSettings
                                              )
                                                ? _vm._i(
                                                    _vm.isSaveSettings,
                                                    null
                                                  ) > -1
                                                : _vm.isSaveSettings,
                                            },
                                            on: {
                                              change: function ($event) {
                                                var $$a = _vm.isSaveSettings,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      (_vm.isSaveSettings =
                                                        $$a.concat([$$v]))
                                                  } else {
                                                    $$i > -1 &&
                                                      (_vm.isSaveSettings = $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        ))
                                                  }
                                                } else {
                                                  _vm.isSaveSettings = $$c
                                                }
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            {
                                              staticClass: "mb-1",
                                              attrs: {
                                                for: "save_settings_panel",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  Save settings\n                "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      (_vm.uploadedFilesCount > 0 ||
                                        _vm.hasUrlInput ||
                                        _vm.previousReports.length > 0) &&
                                      !_vm.isDimensionsReport()
                                        ? _c(
                                            "div",
                                            { staticClass: "form-check mb-1" },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.enableSpecificImages,
                                                    expression:
                                                      "enableSpecificImages",
                                                  },
                                                ],
                                                staticClass: "form-check-input",
                                                attrs: {
                                                  id: "enable-specific-images-panel",
                                                  type: "checkbox",
                                                },
                                                domProps: {
                                                  checked: Array.isArray(
                                                    _vm.enableSpecificImages
                                                  )
                                                    ? _vm._i(
                                                        _vm.enableSpecificImages,
                                                        null
                                                      ) > -1
                                                    : _vm.enableSpecificImages,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    var $$a =
                                                        _vm.enableSpecificImages,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = null,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          (_vm.enableSpecificImages =
                                                            $$a.concat([$$v]))
                                                      } else {
                                                        $$i > -1 &&
                                                          (_vm.enableSpecificImages =
                                                            $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              ))
                                                      }
                                                    } else {
                                                      _vm.enableSpecificImages =
                                                        $$c
                                                    }
                                                  },
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "cursor-pointer mb-1",
                                                  attrs: {
                                                    for: "enable-specific-images-panel",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  Report on specific images only (by image number)\n                "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.enableSpecificImages &&
                                      (_vm.uploadedFilesCount > 0 ||
                                        _vm.hasUrlInput ||
                                        _vm.previousReports.length > 0) &&
                                      !_vm.isDimensionsReport()
                                        ? _c("div", { staticClass: "mt-2" }, [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.specificImageNumbers,
                                                  expression:
                                                    "specificImageNumbers",
                                                },
                                              ],
                                              staticClass:
                                                "form-control form-control-sm",
                                              attrs: {
                                                id: "specific-image-numbers-panel",
                                                type: "text",
                                                placeholder: "e.g., 1, 3, 5",
                                              },
                                              domProps: {
                                                value: _vm.specificImageNumbers,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.specificImageNumbers =
                                                    $event.target.value
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "small",
                                              {
                                                staticClass:
                                                  "text-muted d-block mt-1",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  Enter image numbers separated by commas (e.g., 1, 3, 5). If left empty, all images will be evaluated.\n                "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "small",
                                              {
                                                staticClass:
                                                  "text-muted d-block",
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fas fa-info-circle mr-1",
                                                }),
                                                _vm._v(
                                                  "\n                  Note: All images will still be remembered for reuse in future reports.\n                "
                                                ),
                                              ]
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              !(
                                _vm.isImageComparisonAnalysis() &&
                                _vm.activeTab === 1
                              )
                                ? _c(
                                    "b-button",
                                    {
                                      staticClass: "generate-report",
                                      attrs: {
                                        variant: "primary",
                                        size: "md",
                                        disabled: _vm.nextButtonDisabled,
                                      },
                                      on: { click: _vm.nextStep },
                                    },
                                    [
                                      _vm.isLoading
                                        ? _c("b-spinner", {
                                            staticClass: "mr-2",
                                            attrs: { small: "" },
                                          })
                                        : _c("i", {
                                            staticClass: "fas fa-play mr-2",
                                          }),
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            _vm.isLoading
                                              ? "Generating..."
                                              : "Generate Reports"
                                          ) +
                                          "\n          "
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isImageComparisonAnalysis() && _vm.activeTab === 1
                        ? _c(
                            "div",
                            { staticClass: "right-panel-footer mt-3" },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "generate-report",
                                  attrs: {
                                    variant: "primary",
                                    size: "md",
                                    disabled: _vm.nextButtonDisabled,
                                  },
                                  on: { click: _vm.nextStep },
                                },
                                [
                                  _vm.isLoading
                                    ? _c("b-spinner", {
                                        staticClass: "mr-2",
                                        attrs: { small: "" },
                                      })
                                    : _c("i", {
                                        staticClass: "fas fa-play mr-2",
                                      }),
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.isLoading
                                          ? "Generating..."
                                          : "Continue to the next step: Upload Images"
                                      ) +
                                      "\n          "
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isVisualPlayBookAnalysis()
                        ? _c("div", [
                            _c("div", { staticClass: "mb-3" }, [
                              _c(
                                "label",
                                {
                                  staticClass: "font-weight-bold mb-2 d-block",
                                },
                                [_vm._v("Source")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "d-flex align-items-center",
                                  staticStyle: { gap: "20px" },
                                },
                                [
                                  _c(
                                    "b-form-radio",
                                    {
                                      attrs: {
                                        name: "input-mode",
                                        value: "search",
                                      },
                                      model: {
                                        value: _vm.inputMode,
                                        callback: function ($$v) {
                                          _vm.inputMode = $$v
                                        },
                                        expression: "inputMode",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                Search Term\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-radio",
                                    {
                                      attrs: {
                                        name: "input-mode",
                                        value: "category",
                                      },
                                      model: {
                                        value: _vm.inputMode,
                                        callback: function ($$v) {
                                          _vm.inputMode = $$v
                                        },
                                        expression: "inputMode",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                Category URL\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-radio",
                                    {
                                      attrs: {
                                        name: "input-mode",
                                        value: "products",
                                      },
                                      model: {
                                        value: _vm.inputMode,
                                        callback: function ($$v) {
                                          _vm.inputMode = $$v
                                        },
                                        expression: "inputMode",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                Product URLs\n              "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.inputMode === "search"
                              ? _c(
                                  "div",
                                  { staticClass: "mb-3" },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "visual-benchmark-input",
                                      attrs: {
                                        id: "new-report-search-keyword",
                                        placeholder: "Enter search keyword",
                                      },
                                      model: {
                                        value: _vm.searchKeyword,
                                        callback: function ($$v) {
                                          _vm.searchKeyword = $$v
                                        },
                                        expression: "searchKeyword",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.inputMode === "search" ||
                            _vm.inputMode === "category"
                              ? _c("div", { staticClass: "row mb-3" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-md-6" },
                                    [
                                      _vm._m(4),
                                      _vm._v(" "),
                                      _c("b-form-input", {
                                        staticClass: "visual-benchmark-input",
                                        attrs: {
                                          id: "new-report-include-brands",
                                          placeholder: "Comma-separated",
                                        },
                                        model: {
                                          value: _vm.includeBrands,
                                          callback: function ($$v) {
                                            _vm.includeBrands = $$v
                                          },
                                          expression: "includeBrands",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-6" },
                                    [
                                      _vm._m(5),
                                      _vm._v(" "),
                                      _c("b-form-input", {
                                        staticClass: "visual-benchmark-input",
                                        attrs: {
                                          id: "new-report-exclude-brands",
                                          placeholder: "Comma-separated",
                                        },
                                        model: {
                                          value: _vm.excludeBrands,
                                          callback: function ($$v) {
                                            _vm.excludeBrands = $$v
                                          },
                                          expression: "excludeBrands",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.inputMode === "category"
                              ? _c("div", { staticClass: "mb-3" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "input-group visual-benchmark-input-group",
                                    },
                                    [
                                      _vm._m(6),
                                      _vm._v(" "),
                                      _c("b-form-textarea", {
                                        ref: "categoryUrlsTextarea",
                                        staticClass: "form-control",
                                        attrs: {
                                          placeholder:
                                            "Enter one category URL per line",
                                          rows: "1",
                                        },
                                        on: {
                                          input: _vm.handleCategoryUrlsInput,
                                          keyup: _vm.handleCategoryUrlsInput,
                                          change: _vm.handleCategoryUrlsInput,
                                          paste: _vm.handleCategoryUrlsPaste,
                                        },
                                        model: {
                                          value: _vm.categoryUrlsText,
                                          callback: function ($$v) {
                                            _vm.categoryUrlsText = $$v
                                          },
                                          expression: "categoryUrlsText",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "small",
                                    { staticClass: "text-muted mt-1 d-block" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.categoryUrls.length) +
                                          " URLs entered\n            "
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.inputMode === "products"
                              ? _c("div", { staticClass: "mb-3" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "input-group visual-benchmark-input-group mb-2",
                                    },
                                    [
                                      _vm._m(7),
                                      _vm._v(" "),
                                      _c("b-form-textarea", {
                                        ref: "productUrlsTextarea",
                                        staticClass: "form-control",
                                        attrs: {
                                          placeholder:
                                            "Enter one URL or ASIN per line (max 20)",
                                          rows: "1",
                                        },
                                        on: {
                                          input: _vm.handleProductUrlsInput,
                                          keyup: _vm.handleProductUrlsInput,
                                          change: _vm.handleProductUrlsInput,
                                          paste: _vm.handleProductUrlsPaste,
                                        },
                                        model: {
                                          value: _vm.productUrlsText,
                                          callback: function ($$v) {
                                            _vm.productUrlsText = $$v
                                          },
                                          expression: "productUrlsText",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "small",
                                    { staticClass: "text-muted d-block mb-3" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.productUrls.length) +
                                          "/20 items entered\n              "
                                      ),
                                      _vm.allProductUrls.length > 20
                                        ? _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " - Too many items! Only first 20 will be used."
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("hr", { staticClass: "my-3" }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-md-6" },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label:
                                                "Select from Product List:",
                                            },
                                          },
                                          [
                                            _c("Multiselect", {
                                              attrs: {
                                                options:
                                                  _vm.availableProductLists,
                                                multiple: true,
                                                searchable: true,
                                                loading:
                                                  _vm.isLoadingProductLists,
                                                disabled:
                                                  _vm.isLoadingProductLists,
                                                "track-by": "id",
                                                label: "name",
                                                placeholder:
                                                  "Choose product lists",
                                              },
                                              on: {
                                                input:
                                                  _vm.loadProductsFromProductLists,
                                              },
                                              model: {
                                                value: _vm.selectedProductLists,
                                                callback: function ($$v) {
                                                  _vm.selectedProductLists = $$v
                                                },
                                                expression:
                                                  "selectedProductLists",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.productListProducts.length > 0
                                      ? _c(
                                          "div",
                                          { staticClass: "col-md-6" },
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  label:
                                                    "Select Individual Products:",
                                                },
                                              },
                                              [
                                                _c(
                                                  "Multiselect",
                                                  {
                                                    attrs: {
                                                      options:
                                                        _vm.productListProducts,
                                                      multiple: true,
                                                      searchable: true,
                                                      disabled:
                                                        _vm.isLoadingProducts,
                                                      loading:
                                                        _vm.isLoadingProducts,
                                                      "close-on-select": false,
                                                      "track-by": "id",
                                                      label: "display_name",
                                                      placeholder:
                                                        "Select specific products",
                                                      "allow-empty": true,
                                                      limit: 3,
                                                      "limit-text":
                                                        _vm.limitText,
                                                      "max-height": 300,
                                                    },
                                                    on: {
                                                      input:
                                                        _vm.populateSelectedProductsForPlaybook,
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "option",
                                                          fn: function (props) {
                                                            return [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "multiselect-option",
                                                                },
                                                                [
                                                                  _c("strong", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        props
                                                                          .option
                                                                          .display_name
                                                                      )
                                                                    ),
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "small",
                                                                    {
                                                                      staticClass:
                                                                        "text-muted d-block",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          props
                                                                            .option
                                                                            .product_list_name
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      false,
                                                      2136968834
                                                    ),
                                                    model: {
                                                      value:
                                                        _vm.selectedProducts,
                                                      callback: function ($$v) {
                                                        _vm.selectedProducts =
                                                          $$v
                                                      },
                                                      expression:
                                                        "selectedProducts",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(" "),
                                                    _c(
                                                      "template",
                                                      { slot: "noResult" },
                                                      [
                                                        _vm._v(
                                                          "\n                      No products found\n                    "
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  2
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "mt-2" },
                                                  [
                                                    _c(
                                                      "b-button",
                                                      {
                                                        staticClass: "mr-2",
                                                        attrs: {
                                                          variant:
                                                            _vm.selectedProducts
                                                              .length ===
                                                            _vm
                                                              .productListProducts
                                                              .length
                                                              ? "primary"
                                                              : "outline-primary",
                                                          size: "sm",
                                                          disabled:
                                                            _vm.isLoadingProducts ||
                                                            _vm
                                                              .productListProducts
                                                              .length === 0,
                                                        },
                                                        on: {
                                                          click:
                                                            _vm.selectAllProductsForPlaybook,
                                                        },
                                                      },
                                                      [
                                                        _c("b-icon", {
                                                          attrs: {
                                                            icon:
                                                              _vm
                                                                .selectedProducts
                                                                .length ===
                                                              _vm
                                                                .productListProducts
                                                                .length
                                                                ? "check-square"
                                                                : "square",
                                                          },
                                                        }),
                                                        _vm._v(
                                                          " Select All\n                    "
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.selectedProducts
                                                      .length > 0
                                                      ? _c(
                                                          "b-button",
                                                          {
                                                            attrs: {
                                                              variant:
                                                                "outline-danger",
                                                              size: "sm",
                                                            },
                                                            on: {
                                                              click:
                                                                _vm.clearAllProductsForPlaybook,
                                                            },
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fas fa-times",
                                                            }),
                                                            _vm._v(
                                                              " Clear All\n                    "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.inputMode === "search" ||
                            _vm.inputMode === "category"
                              ? _c("div", { staticClass: "row mb-3" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-md-8" },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "font-weight-bold mb-2 d-block",
                                        },
                                        [_vm._v("Retailer")]
                                      ),
                                      _vm._v(" "),
                                      _c("b-form-select", {
                                        staticClass: "visual-benchmark-select",
                                        attrs: {
                                          id: "new-report-retailer",
                                          options: _vm.retailers,
                                          "value-field": "id",
                                          "text-field": "name",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "first",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "b-form-select-option",
                                                    { attrs: { value: null } },
                                                    [
                                                      _vm._v(
                                                        "\n                    Select retailer\n                  "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          false,
                                          2748898310
                                        ),
                                        model: {
                                          value: _vm.selectedRetailer,
                                          callback: function ($$v) {
                                            _vm.selectedRetailer = $$v
                                          },
                                          expression: "selectedRetailer",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "font-weight-bold mb-2 d-block",
                                        },
                                        [_vm._v("Results")]
                                      ),
                                      _vm._v(" "),
                                      _c("b-form-input", {
                                        staticClass: "visual-benchmark-input",
                                        attrs: {
                                          id: "new-report-number-of-processed-results",
                                          type: "number",
                                        },
                                        model: {
                                          value: _vm.countResults,
                                          callback: function ($$v) {
                                            _vm.countResults = $$v
                                          },
                                          expression: "countResults",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.inputMode === "products"
                              ? _c(
                                  "div",
                                  { staticClass: "mb-3" },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "font-weight-bold mb-2 d-block",
                                      },
                                      [_vm._v("Max Images Per Product")]
                                    ),
                                    _vm._v(" "),
                                    _c("b-form-input", {
                                      staticClass: "visual-benchmark-input",
                                      attrs: {
                                        placeholder:
                                          "Number of max images per product",
                                        type: "number",
                                      },
                                      model: {
                                        value: _vm.maxImagesPerProduct,
                                        callback: function ($$v) {
                                          _vm.maxImagesPerProduct = $$v
                                        },
                                        expression: "maxImagesPerProduct",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
            ]
          )
        : _vm.step === 4
        ? _c("div", [
            _vm.isAnalyzing
              ? _c(
                  "div",
                  { staticClass: "text-center mt-5" },
                  [
                    !_vm.showLoadingStatus
                      ? _c(
                          "div",
                          {
                            staticClass: "offset-3 col-md-6",
                            staticStyle: {
                              "text-align": "center",
                              padding: "20px",
                            },
                          },
                          [
                            _c(
                              "h4",
                              { staticClass: "text-success" },
                              [
                                _c("b-icon", {
                                  staticClass: "mr-2",
                                  attrs: { icon: "hourglass-split" },
                                }),
                                _vm._v(
                                  "\n          Analysis in progress\n        "
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("p", { staticClass: "mb-0" }, [
                              _vm._v(
                                "\n          Do not close/reload this page...\n        "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-progress",
                              {
                                staticClass: "mt-3",
                                attrs: {
                                  value: _vm.fakePercents,
                                  max: 100,
                                  height: "20px",
                                  animated: "",
                                  striped: _vm.isPolling,
                                },
                              },
                              [
                                _c(
                                  "b-progress-bar",
                                  { attrs: { value: _vm.fakePercents } },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.fakePercents) +
                                        "%\n          "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("p", { staticClass: "mt-2" }, [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.currentProcess) +
                                  "\n        "
                              ),
                            ]),
                          ],
                          1
                        )
                      : _c("div", { staticClass: "mt-2 loading-status" }, [
                          _c("div", [
                            _c("h4", { staticClass: "mt-4" }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.loadingStatusText) +
                                  "\n          "
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.loadingStatusHelperText) +
                                "\n        "
                            ),
                          ]),
                        ]),
                    _vm._v(" "),
                    _vm._l(_vm.analysisReports, function (report) {
                      return _c(
                        "div",
                        {
                          key: typeof report === "object" ? report.url : report,
                          staticClass:
                            "order-analysis-summary mb-4 p-3 border rounded bg-light",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "text-align": "center",
                                padding: "20px",
                              },
                            },
                            [
                              _c(
                                "h4",
                                { staticClass: "text-success" },
                                [
                                  _c("b-icon", {
                                    staticClass: "mr-2",
                                    attrs: { icon: "check-circle" },
                                  }),
                                  _vm._v(
                                    "\n            Analysis Report Generated\n          "
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  "\n            Your analysis report has been created successfully.\n          "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "btn btn-primary",
                                  attrs: {
                                    href:
                                      typeof report === "object"
                                        ? report.url
                                        : report,
                                    target: "_blank",
                                    title:
                                      typeof report === "object"
                                        ? report.originalUrl
                                        : report,
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "fas fa-external-link-alt mr-2",
                                  }),
                                  _vm._v(
                                    "\n            Open Analysis Report\n          "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                )
              : _vm.isRedirecting
              ? _c("div", [
                  _c(
                    "div",
                    {
                      staticClass:
                        "order-analysis-summary mb-4 p-3 border rounded bg-light",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "text-align": "center",
                            padding: "20px",
                          },
                        },
                        [
                          _c(
                            "h4",
                            { staticClass: "text-success" },
                            [
                              _c("b-icon", {
                                staticClass: "mr-2",
                                attrs: { icon: "check-circle" },
                              }),
                              _vm._v(
                                "\n            Analysis Report Generated Successfully!\n          "
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "\n            Redirecting to your reports...\n          "
                            ),
                          ]),
                          _vm._v(" "),
                          _vm._m(8),
                        ]
                      ),
                    ]
                  ),
                ])
              : !_vm.isRedirecting
              ? _c("div", [
                  _c("h3", [_vm._v("Analysis Results")]),
                  _vm._v(" "),
                  _vm.analysisReportUrl
                    ? _c("div", [
                        _c(
                          "div",
                          {
                            staticClass:
                              "order-analysis-summary mb-4 p-3 border rounded bg-light",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "text-align": "center",
                                  padding: "20px",
                                },
                              },
                              [
                                _c(
                                  "h4",
                                  { staticClass: "text-success" },
                                  [
                                    _c("b-icon", {
                                      staticClass: "mr-2",
                                      attrs: { icon: "check-circle" },
                                    }),
                                    _vm._v(
                                      "\n              Analysis Report Generated\n            "
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "\n              Your analysis report has been created successfully.\n            "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "btn btn-primary",
                                    attrs: {
                                      href: _vm.analysisReportUrl,
                                      target: "_blank",
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fas fa-external-link-alt mr-2",
                                    }),
                                    _vm._v(
                                      "\n              Open Analysis Report\n            "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ])
                    : _vm.analysisReports.length > 0
                    ? _c("div", [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "text-align": "center",
                              "margin-top": "20px",
                            },
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-success mb-4",
                                on: { click: _vm.downloadReports },
                              },
                              [
                                _c("i", {
                                  staticClass: "fas fa-file-excel mr-2",
                                }),
                                _vm._v(
                                  "\n            Download All Links to Reports (XLSX)\n          "
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "order-analysis-summary mb-4 p-3 border rounded bg-light",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "text-align": "center",
                                  padding: "20px",
                                },
                              },
                              [
                                _c(
                                  "h4",
                                  { staticClass: "text-success" },
                                  [
                                    _c("b-icon", {
                                      staticClass: "mr-2",
                                      attrs: { icon: "check-circle" },
                                    }),
                                    _vm._v(
                                      "\n              Analysis Report Generated\n            "
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "\n              Your analysis report has been created successfully.\n            "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex flex-wrap justify-content-center gap-2",
                                  },
                                  _vm._l(
                                    _vm.analysisReports,
                                    function (report, index) {
                                      return _c(
                                        "a",
                                        {
                                          key:
                                            typeof report === "object"
                                              ? report.url
                                              : report,
                                          staticClass: "btn btn-primary",
                                          staticStyle: { margin: "5px" },
                                          attrs: {
                                            href:
                                              typeof report === "object"
                                                ? report.url
                                                : report,
                                            target: "_blank",
                                            title:
                                              typeof report === "object"
                                                ? report.originalUrl
                                                : report,
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fas fa-external-link-alt mr-2",
                                          }),
                                          _vm._v(
                                            "\n                Open Analysis Report " +
                                              _vm._s(index + 1) +
                                              "\n              "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]
                            ),
                          ]
                        ),
                      ])
                    : _vm.isBackgroundJob
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "order-analysis-summary mb-4 p-3 border rounded bg-light",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "text-align": "center",
                                padding: "20px",
                              },
                            },
                            [
                              _c(
                                "h4",
                                { staticClass: "text-success" },
                                [
                                  _c("b-icon", {
                                    staticClass: "mr-2",
                                    attrs: { icon: "check-circle" },
                                  }),
                                  _vm._v(
                                    "\n            Analysis in progress\n          "
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  "You can navigate away and we will notify you when the report is ready."
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-progress",
                                {
                                  staticClass: "mt-3",
                                  attrs: {
                                    value: _vm.overallProgressPercent,
                                    max: 100,
                                    height: "20px",
                                    animated: "",
                                    striped: _vm.isPolling,
                                  },
                                },
                                [
                                  _c(
                                    "b-progress-bar",
                                    {
                                      attrs: {
                                        value: _vm.overallProgressPercent,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.overallProgressPercent) +
                                          "%\n            "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.backgroundProcesses.length
                                ? _c(
                                    "div",
                                    { staticClass: "text-left mt-3" },
                                    _vm._l(
                                      _vm.backgroundProcesses,
                                      function (job) {
                                        return _c(
                                          "div",
                                          {
                                            key: job.id,
                                            staticClass:
                                              "d-flex justify-content-between align-items-center py-1 border-bottom",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex align-items-center",
                                              },
                                              [
                                                _vm.isJobRunning(job)
                                                  ? _c("b-icon", {
                                                      staticClass: "mr-2",
                                                      attrs: {
                                                        icon: "arrow-clockwise",
                                                        animation: "spin",
                                                      },
                                                    })
                                                  : _vm.isJobSucceeded(job)
                                                  ? _c("b-icon", {
                                                      staticClass:
                                                        "text-success mr-2",
                                                      attrs: {
                                                        icon: "check-circle-fill",
                                                      },
                                                    })
                                                  : _vm.isJobFailed(job)
                                                  ? _c("b-icon", {
                                                      staticClass:
                                                        "text-danger mr-2",
                                                      attrs: {
                                                        icon: "x-circle-fill",
                                                      },
                                                    })
                                                  : _vm.isJobCancelled(job)
                                                  ? _c("b-icon", {
                                                      staticClass:
                                                        "text-muted mr-2",
                                                      attrs: {
                                                        icon: "dash-circle-fill",
                                                      },
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "font-weight-500",
                                                  },
                                                  [
                                                    job.name
                                                      ? [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(job.name) +
                                                              "\n                  "
                                                          ),
                                                        ]
                                                      : [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "job-id-container",
                                                            },
                                                            [
                                                              _c(
                                                                "small",
                                                                {
                                                                  staticClass:
                                                                    "see-job-id-link text-muted",
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          job,
                                                                          "showJobId",
                                                                          !job.showJobId
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                        " +
                                                                      _vm._s(
                                                                        job.showJobId
                                                                          ? "Hide Job ID"
                                                                          : "See Job ID"
                                                                      ) +
                                                                      "\n                      "
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              job.showJobId
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "job-id-display",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                        Job #" +
                                                                          _vm._s(
                                                                            job.uuid
                                                                          ) +
                                                                          "\n                        "
                                                                      ),
                                                                      _c(
                                                                        "b-icon",
                                                                        {
                                                                          staticClass:
                                                                            "copy-icon ml-1",
                                                                          attrs:
                                                                            {
                                                                              icon: "clipboard",
                                                                              title:
                                                                                "Copy Job ID",
                                                                            },
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                $event.stopPropagation()
                                                                                return _vm.copyJobId(
                                                                                  job.uuid
                                                                                )
                                                                              },
                                                                          },
                                                                        }
                                                                      ),
                                                                    ],
                                                                    1
                                                                  )
                                                                : _vm._e(),
                                                            ]
                                                          ),
                                                        ],
                                                    _vm._v(" "),
                                                    job.links
                                                      ? _c(
                                                          "span",
                                                          _vm._l(
                                                            job.links,
                                                            function (link) {
                                                              return _c(
                                                                "a",
                                                                {
                                                                  key: link,
                                                                  attrs: {
                                                                    href: link,
                                                                    target:
                                                                      "_blank",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Open Report"
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  2
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "small",
                                              { staticClass: "text-muted" },
                                              [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(
                                                      (
                                                        job.status || "queued"
                                                      ).toUpperCase()
                                                    ) +
                                                    "\n                "
                                                ),
                                                typeof job.progress === "number"
                                                  ? [
                                                      _vm._v(
                                                        " · " +
                                                          _vm._s(
                                                            Math.round(
                                                              job.progress
                                                            )
                                                          ) +
                                                          "%"
                                                      ),
                                                    ]
                                                  : _vm._e(),
                                              ],
                                              2
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm.analysisError
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "order-analysis-summary mb-4 p-3 border rounded bg-light",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "text-align": "center",
                                padding: "20px",
                              },
                            },
                            [
                              _c(
                                "h4",
                                {
                                  class: _vm.isImageCrawlingError
                                    ? "text-muted"
                                    : "text-danger",
                                },
                                [
                                  _c("b-icon", {
                                    staticClass: "mr-2",
                                    attrs: {
                                      icon: _vm.isImageCrawlingError
                                        ? "info-circle"
                                        : "exclamation-circle",
                                    },
                                  }),
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.isImageCrawlingError
                                          ? "No Images Found"
                                          : "Analysis Error"
                                      ) +
                                      "\n          "
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              !_vm.isImageCrawlingError
                                ? _c("p", [
                                    _vm._v(
                                      "\n            There was an error while generating the analysis\n          "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "b-button",
                                {
                                  attrs: { variant: "outline-primary" },
                                  on: { click: _vm.retryAnalysis },
                                },
                                [
                                  _c("b-icon", {
                                    staticClass: "mr-2",
                                    attrs: { icon: "arrow-repeat" },
                                  }),
                                  _vm._v("\n            Try Again\n          "),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      )
                    : !_vm.isRedirecting
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "order-analysis-summary mb-4 p-3 border rounded",
                        },
                        [_vm._m(9)]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt-4 text-center" },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "primary", size: "lg" },
                          on: { click: _vm.startNewAnalysis },
                        },
                        [
                          _c("b-icon", { attrs: { icon: "arrow-clockwise" } }),
                          _vm._v("\n          New Analysis\n        "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.step < _vm.lastStep && _vm.step >= 2
        ? _c(
            "div",
            {
              staticClass: "my-1 d-flex",
              class: _vm.isOptixLab ? "justify-content-between" : "",
            },
            [
              _c(
                "div",
                { staticClass: "d-flex flex-grow-1" },
                [
                  _vm.step > 2 &&
                  _vm.viewMode !== "list" &&
                  !_vm.isConfigViewOpen
                    ? _c(
                        "b-button",
                        {
                          staticClass: "btn-group-style h-fit",
                          attrs: { variant: "secondary" },
                          on: { click: _vm.previousStep },
                        },
                        [
                          _c("b-icon", { attrs: { icon: "arrow-left" } }),
                          _vm._v("\n        Previous\n      "),
                        ],
                        1
                      )
                    : !_vm.isOptixLab
                    ? _c(
                        "b-button",
                        {
                          attrs: {
                            variant: "secondary",
                            to: { name: "dashboard" },
                          },
                        },
                        [
                          _c("b-icon", {
                            attrs: { icon: "x-lg", scale: "0.75" },
                          }),
                          _vm._v("\n        Cancel\n      "),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              (!_vm.isOptixLab || (_vm.isOptixLab && _vm.step === 2)) &&
              !_vm.isConfigViewOpen
                ? _c(
                    "b-button",
                    {
                      class: !_vm.isOptixLab ? "ml-2" : "d-none",
                      attrs: {
                        variant: "primary",
                        disabled: _vm.nextButtonDisabled,
                      },
                      on: { click: _vm.nextStep },
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _vm.step < _vm.lastStep ? "Next" : "Start Analysis"
                          ) +
                          "\n      "
                      ),
                      _vm.step < _vm.lastStep
                        ? _c("b-icon", { attrs: { icon: "arrow-right" } })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.step > 2 &&
              _vm.isOptixLab &&
              !_vm.isConfigViewOpen &&
              _vm.isVisualPlayBookAnalysis()
                ? _c(
                    "div",
                    {
                      staticClass: "d-flex justify-content-center flex-grow-1",
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "generate-report h-fit",
                          attrs: {
                            variant: "primary",
                            size: "md",
                            disabled: _vm.nextButtonDisabled,
                          },
                          on: { click: _vm.nextStep },
                        },
                        [
                          _vm.isLoading
                            ? _c("b-spinner", {
                                staticClass: "mr-2",
                                attrs: { small: "" },
                              })
                            : _c("i", { staticClass: "fas fa-play mr-2" }),
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.isLoading
                                  ? "Generating..."
                                  : "Generate Reports"
                              ) +
                              "\n      "
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("SelectFolderModal", {
        attrs: {
          mode: _vm.selectFolderMode,
          "view-tabs": _vm.selectFolderModal.viewTabs,
          "modal-title": _vm.selectFolderModal.modalTitle,
        },
        on: { onSelectedItems: _vm.fileBrowserItemSelected },
      }),
      _vm._v(" "),
      _c("SelectLayoutModal", {
        on: { onSelectedItems: _vm.layoutItemSelected },
      }),
      _vm._v(" "),
      _c("ExportToLayoutModal", {
        attrs: { show: _vm.showExportToLayoutModal },
        on: { onExportToLayout: _vm.handleExportToLayout },
      }),
      _vm._v(" "),
      _c("ExternalAssetsView", {
        attrs: { source: _vm.externalAssetsSource },
        on: { onSelectedAssets: _vm.handleExternalAssetsSelected },
      }),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "export-status",
            title: _vm.isExporting
              ? "Copying Images To Layout..."
              : "Images Copied",
            "ok-only": "",
            "ok-disabled": _vm.isExporting,
            "hide-footer": _vm.isExporting,
          },
        },
        [
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _vm.isExporting
                ? _c("b-spinner", {
                    staticClass: "spinner-custom",
                    attrs: { variant: "primary" },
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.isExporting
                ? _c(
                    "div",
                    [
                      _c("div", [
                        _vm._v(
                          "\n          All images were successfully copied to the layout.\n        "
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.layoutURL
                        ? _c(
                            "b-button",
                            {
                              staticClass: "mt-2",
                              attrs: {
                                variant: "primary",
                                href: _vm.layoutURL,
                              },
                            },
                            [_vm._v("\n          View Layout\n        ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "previous-report-modal",
            title: "Incorporate previous report",
            centered: "",
            "ok-title": "Select",
            "cancel-title": "Cancel",
            "ok-disabled": !_vm.tempSelectedPreviousReportId,
          },
          on: {
            ok: _vm.confirmPreviousReportSelection,
            show: function ($event) {
              _vm.tempSelectedPreviousReportId = _vm.selectedPreviousReportId
            },
          },
        },
        [
          _c(
            "div",
            [
              _c("Multiselect", {
                attrs: {
                  value: _vm.previousReports.find(
                    (r) => r.id === _vm.tempSelectedPreviousReportId
                  ),
                  options: _vm.previousReports,
                  "track-by": "id",
                  label: "name",
                  placeholder: "Select a previous report",
                  "select-label": "",
                  "deselect-label": "",
                  searchable: false,
                  "allow-empty": true,
                },
                on: {
                  input: (val) => {
                    _vm.tempSelectedPreviousReportId = val ? val.id : null
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "option",
                    fn: function (props) {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "mr-2 rounded border overflow-hidden d-flex align-items-center justify-content-center bg-light",
                                staticStyle: {
                                  width: "30px",
                                  height: "30px",
                                  "min-width": "30px",
                                },
                              },
                              [
                                props.option.thumbnail
                                  ? _c("img", {
                                      staticStyle: {
                                        width: "100%",
                                        height: "100%",
                                        "object-fit": "cover",
                                      },
                                      attrs: { src: props.option.thumbnail },
                                    })
                                  : _c("i", {
                                      staticClass: "bi bi-file-text text-muted",
                                    }),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticStyle: { overflow: "hidden" } }, [
                              _c("div", { staticClass: "text-truncate" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(props.option.name) +
                                    "\n              "
                                ),
                              ]),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                  {
                    key: "singleLabel",
                    fn: function (props) {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "mr-2 rounded border overflow-hidden d-flex align-items-center justify-content-center bg-light",
                                staticStyle: {
                                  width: "20px",
                                  height: "20px",
                                  "min-width": "20px",
                                },
                              },
                              [
                                props.option.thumbnail
                                  ? _c("img", {
                                      staticStyle: {
                                        width: "100%",
                                        height: "100%",
                                        "object-fit": "cover",
                                      },
                                      attrs: { src: props.option.thumbnail },
                                    })
                                  : _c("i", {
                                      staticClass:
                                        "bi bi-file-text text-muted small",
                                    }),
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "text-truncate" }, [
                              _vm._v(_vm._s(props.option.name)),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _vm.tempSelectedPreviousReportId && _vm.selectedPreviousReport
                ? _c(
                    "div",
                    { staticClass: "mt-3 p-3 bg-light rounded border" },
                    [
                      _c("div", { staticClass: "d-flex" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "mr-3 rounded border overflow-hidden d-flex align-items-center justify-content-center bg-white",
                            staticStyle: {
                              width: "80px",
                              height: "80px",
                              "min-width": "80px",
                            },
                          },
                          [
                            _vm.selectedPreviousReport.thumbnail
                              ? _c("img", {
                                  staticStyle: {
                                    width: "100%",
                                    height: "100%",
                                    "object-fit": "cover",
                                  },
                                  attrs: {
                                    src: _vm.selectedPreviousReport.thumbnail,
                                  },
                                })
                              : _c("i", {
                                  staticClass:
                                    "bi bi-file-text text-muted h3 mb-0",
                                }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticStyle: { overflow: "hidden", flex: "1" } },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "font-weight-bold mb-1",
                                attrs: {
                                  title: _vm.selectedPreviousReport.name,
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.selectedPreviousReport.name) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "text-muted small" }, [
                              _c("i", { staticClass: "bi bi-calendar mr-1" }),
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.selectedPreviousReport.created_at
                                  ) +
                                  "\n            "
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.tempSelectedPreviousReportId || _vm.selectedPreviousReportId
                ? _c("div", { staticClass: "mt-3" }, [
                    _c(
                      "span",
                      {
                        staticClass: "text-danger cursor-pointer",
                        attrs: { role: "button" },
                        on: { click: _vm.clearPreviousReportSelection },
                      },
                      [
                        _c("i", { staticClass: "bi bi-x-circle mr-1" }),
                        _vm._v("\n          Clear selection\n        "),
                      ]
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "page-screenshot-modal",
            title: "Capture Page Screenshot",
            centered: "",
            "ok-title": "Capture",
            "cancel-title": "Cancel",
            "ok-disabled": !_vm.screenshotUrl || _vm.isCapturingScreenshot,
          },
          on: {
            ok: _vm.capturePageScreenshot,
            hidden: _vm.resetScreenshotModal,
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "Enter the webpage URL or Amazon ASIN",
                    description: "The full page will be captured as an image",
                  },
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      placeholder:
                        "https://example.com/product-page or B000XDIEDE",
                      disabled: _vm.isCapturingScreenshot,
                    },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.capturePageScreenshot.apply(null, arguments)
                      },
                    },
                    model: {
                      value: _vm.screenshotUrl,
                      callback: function ($$v) {
                        _vm.screenshotUrl = $$v
                      },
                      expression: "screenshotUrl",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "advanced-options-toggle mt-3",
                  on: {
                    click: function ($event) {
                      _vm.showScreenshotAdvanced = !_vm.showScreenshotAdvanced
                    },
                  },
                },
                [
                  _c("i", {
                    staticClass: "fas fa-chevron-right mr-2",
                    class: { "rotate-90": _vm.showScreenshotAdvanced },
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Advanced Options")]),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-collapse",
                {
                  model: {
                    value: _vm.showScreenshotAdvanced,
                    callback: function ($$v) {
                      _vm.showScreenshotAdvanced = $$v
                    },
                    expression: "showScreenshotAdvanced",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "mt-2" },
                    [
                      _c(
                        "b-form-checkbox",
                        {
                          attrs: { disabled: _vm.isCapturingScreenshot },
                          model: {
                            value: _vm.screenshotAsChunks,
                            callback: function ($$v) {
                              _vm.screenshotAsChunks = $$v
                            },
                            expression: "screenshotAsChunks",
                          },
                        },
                        [
                          _vm._v(
                            "\n            Capture as chunks (split long page into multiple images)\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-collapse",
                        { attrs: { visible: _vm.screenshotAsChunks } },
                        [
                          _c(
                            "div",
                            { staticClass: "p-2 mt-2 border rounded" },
                            [
                              _c(
                                "b-form-row",
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { cols: "12", md: "4" } },
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: { label: "Chunk height (px)" },
                                        },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              type: "number",
                                              min: "300",
                                              max: "3000",
                                              step: "50",
                                              disabled:
                                                _vm.isCapturingScreenshot,
                                            },
                                            model: {
                                              value: _vm.screenshotChunkHeight,
                                              callback: function ($$v) {
                                                _vm.screenshotChunkHeight =
                                                  _vm._n($$v)
                                              },
                                              expression:
                                                "screenshotChunkHeight",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { cols: "12", md: "4" } },
                                    [
                                      _c(
                                        "b-form-group",
                                        { attrs: { label: "Overlap (px)" } },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              type: "number",
                                              min: "0",
                                              max: "800",
                                              step: "10",
                                              disabled:
                                                _vm.isCapturingScreenshot,
                                            },
                                            model: {
                                              value: _vm.screenshotChunkOverlap,
                                              callback: function ($$v) {
                                                _vm.screenshotChunkOverlap =
                                                  _vm._n($$v)
                                              },
                                              expression:
                                                "screenshotChunkOverlap",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { cols: "12", md: "4" } },
                                    [
                                      _c(
                                        "b-form-group",
                                        { attrs: { label: "Max chunks" } },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              type: "number",
                                              min: "1",
                                              max: "50",
                                              step: "1",
                                              disabled:
                                                _vm.isCapturingScreenshot,
                                            },
                                            model: {
                                              value: _vm.screenshotMaxChunks,
                                              callback: function ($$v) {
                                                _vm.screenshotMaxChunks =
                                                  _vm._n($$v)
                                              },
                                              expression: "screenshotMaxChunks",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("small", { staticClass: "text-muted" }, [
                                _vm._v(
                                  "\n                Tip: overlap helps if elements are cut between chunks.\n              "
                                ),
                              ]),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-checkbox",
                        {
                          staticClass: "mt-2",
                          attrs: { disabled: _vm.isCapturingScreenshot },
                          model: {
                            value: _vm.smartScreenshot,
                            callback: function ($$v) {
                              _vm.smartScreenshot = $$v
                            },
                            expression: "smartScreenshot",
                          },
                        },
                        [_vm._v("\n            Smart Screenshot\n          ")]
                      ),
                      _vm._v(" "),
                      _vm.screenshotUrl && _vm.detectRetailer(_vm.screenshotUrl)
                        ? _c(
                            "b-form-checkbox",
                            {
                              staticClass: "mt-2",
                              attrs: { disabled: _vm.isCapturingScreenshot },
                              model: {
                                value: _vm.parsePdpImages,
                                callback: function ($$v) {
                                  _vm.parsePdpImages = $$v
                                },
                                expression: "parsePdpImages",
                              },
                            },
                            [
                              _vm._v(
                                "\n            Parse PDP Images (will be attached to the report)\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.isCapturingScreenshot
                ? _c(
                    "div",
                    { staticClass: "text-center mt-3" },
                    [
                      _c("b-spinner", {
                        staticClass: "mr-2",
                        attrs: { small: "" },
                      }),
                      _vm._v("\n        Capturing screenshot...\n      "),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _vm.showLightbox
        ? _c(
            "div",
            {
              staticClass: "lightbox-backdrop",
              on: { click: _vm.closeLightbox },
            },
            [
              _c("div", { staticClass: "lightbox-header" }, [
                _c(
                  "button",
                  {
                    staticClass: "lightbox-download",
                    attrs: { type: "button", title: "Download" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.downloadLightboxImage.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "lucide-icon lucide lucide-download",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "24",
                          height: "24",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      },
                      [
                        _c("path", { attrs: { d: "M12 15V3" } }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", { attrs: { d: "m7 10 5 5 5-5" } }),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "lightbox-close",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.closeLightbox.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "lucide-icon lucide lucide-x",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "24",
                          height: "24",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      },
                      [
                        _c("path", { attrs: { d: "M18 6 6 18" } }),
                        _vm._v(" "),
                        _c("path", { attrs: { d: "m6 6 12 12" } }),
                      ]
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _vm.lightboxImages.length > 1 && _vm.currentLightboxIndex > 0
                ? _c(
                    "button",
                    {
                      staticClass: "lightbox-nav lightbox-prev",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.prevImage.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "svg",
                        {
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "32",
                            height: "32",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        },
                        [
                          _c("polyline", {
                            attrs: { points: "15 18 9 12 15 6" },
                          }),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.lightboxImages.length > 1 &&
              _vm.currentLightboxIndex < _vm.lightboxImages.length - 1
                ? _c(
                    "button",
                    {
                      staticClass: "lightbox-nav lightbox-next",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.nextImage.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "svg",
                        {
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "32",
                            height: "32",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        },
                        [
                          _c("polyline", {
                            attrs: { points: "9 18 15 12 9 6" },
                          }),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "lightbox-modal",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                    },
                  },
                },
                [
                  _vm.lightboxImage
                    ? _c("img", {
                        staticClass: "lightbox-image",
                        attrs: {
                          src: _vm.lightboxImage,
                          alt: "Preview",
                          draggable: "false",
                        },
                        on: {
                          dragstart: function ($event) {
                            $event.preventDefault()
                          },
                        },
                      })
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _vm.lightboxImages.length > 1
                ? _c("div", { staticClass: "lightbox-counter" }, [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.currentLightboxIndex + 1) +
                        " / " +
                        _vm._s(_vm.lightboxImages.length) +
                        "\n    "
                    ),
                  ])
                : _vm._e(),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-content" }, [
      _c("div", { staticClass: "icon-container" }, [
        _c("i", { staticClass: "bi bi-handbag font-icons" }),
      ]),
      _vm._v(" "),
      _c("h3", { staticClass: "card-title" }, [
        _vm._v("\n              PDP Images\n            "),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "card-description" }, [
        _vm._v(
          "\n              Product pages, eCommerce carousels, mobile readiness, and packaging views\n            "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-content" }, [
      _c("div", { staticClass: "icon-container" }, [
        _c("i", { staticClass: "bi bi-megaphone font-icons" }),
      ]),
      _vm._v(" "),
      _c("h3", { staticClass: "card-title" }, [
        _vm._v("\n              Banner Ads\n            "),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "card-description" }, [
        _vm._v(
          "\n              Display creatives, call-to action effectiveness, size compliance\n            "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "prompt-card-footer" }, [
      _c(
        "button",
        { staticClass: "btn btn-sm w-100", attrs: { type: "button" } },
        [
          _c("span", { staticClass: "float-left" }, [_vm._v("Start Analysis")]),
          _vm._v(" "),
          _c("i", { staticClass: "bi bi-chevron-right m-0 float-right" }),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("div", { staticClass: "font-weight-bold" }, [
        _vm._v("\n                  KPI Settings\n                "),
      ]),
      _vm._v(" "),
      _c("small", { staticClass: "text-muted" }, [
        _vm._v(
          "\n                  These KPI fields come from the selected prompt and will be sent with the analysis request.\n                "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "mb-2 d-block" }, [
      _c("span", { staticClass: "font-weight-bold" }, [
        _vm._v("Include Brands"),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "text-muted" }, [_vm._v(" (optional)")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "mb-2 d-block" }, [
      _c("span", { staticClass: "font-weight-bold" }, [
        _vm._v("Exclude Brands"),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "text-muted" }, [_vm._v(" (optional)")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "bi bi-link-45deg" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "bi bi-link-45deg" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "spinner-border text-primary", attrs: { role: "status" } },
      [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticStyle: { "text-align": "center", padding: "20px" } },
      [
        _c("p", { staticClass: "text-muted" }, [
          _vm._v("\n            No analysis results available.\n          "),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }